import { useEffect, useMemo, useState } from "react";
import { Box, Card, Stack, Typography, IconButton,Collapse, TextField, Button, Divider, CircularProgress, Tooltip, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, MenuItem, CardHeader, CardContent, Chip, Grid, FormControlLabel, Checkbox, Alert, FormControl, InputLabel, Select, useMediaQuery } from "@mui/material";
import AppPaginationBar from "components/AppPaginationBar";
import { Delete, Edit, Save, Close, Refresh, Add, ShoppingCart } from "@mui/icons-material";
import { alpha, styled, useTheme } from "@mui/material/styles";
import apiService from "Network/apiService";
import { API_ENDPOINTS } from "Network/apiEndpoints";
import { useToast } from "OtherReusableFunctionality/ToastContext";
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import React, { Fragment } from "react";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  Close as CloseIcon,
  Add as AddIcon,
  Receipt as ReceiptIcon,
   Assignment as ChallanIcon,
  Email as EmailIcon,
    PictureAsPdf as PdfIcon,
  LocalShipping as DeliveryIcon,
   Download as DownloadIcon,
   Send as SendIcon

} from '@mui/icons-material';
import { usePageTitle } from "contexts/PageTitleContext";
import buttonConfig from "config/ConfigAccessButton";

const quotationPageInFlightGets = new Map();
const dedupedGet = (url) => {
  if (quotationPageInFlightGets.has(url)) {
    return quotationPageInFlightGets.get(url);
  }
  const promise = apiService.get(url).finally(() => {
    quotationPageInFlightGets.delete(url);
  });
  quotationPageInFlightGets.set(url, promise);
  return promise;
};

const PageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const HeaderCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const TableCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const Row = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '64px 1fr 160px 240px',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(1.5, 0),
}));

const HeaderRow = styled(Row)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 600,
}));

const Muted = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

const ActionWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  justifyContent: 'flex-end',
}));

const InvoiceModal = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    maxWidth: '90vw',
    maxHeight: '90vh',
    width: '1200px',
    height: '800px',
    margin: theme.spacing(2),
  },
}));

const InvoiceFrame = styled('iframe')(({ theme }) => ({
  width: '100%',
  height: '100%',
  border: 'none',
  borderRadius: theme.shape.borderRadius,
}));

const QuotationProformaInvoice = () => {
  const theme = useTheme();
  const isMobileDialog = useMediaQuery(theme.breakpoints.down("sm"));
  const { showSuccess, showError } = useToast();
const [openRow, setOpenRow] = useState(null);
 const { setPageTitle } = usePageTitle();
    useEffect(() => {
        setPageTitle('Quotation');
    }, [setPageTitle]);

const [quotations, setQuotations] = useState([]);
const [loadingQuo, setLoadingQuo] = useState(false);
const [totalQuotations, setTotalQuotations] = useState(null);
const [loadingDashboard, setLoadingDashboard] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    page_size: 10,
    total_items: 0,
    total_pages: 1,
    has_next: false,
    has_previous: false,
    next_page_number: null,
    previous_page_number: null,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const pageSizeOptions = [10, 25, 50, 100];

  const userId = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("logged_data"))?.data?.id || JSON.parse(localStorage.getItem("logged_data"))?.data?.user_id || 1;
    } catch (_) {
      return 1;
    }
  }, []);

const [statusOptions, setStatusOptions] = useState([]);
const [formData, setFormData] = useState({
  name: "",
  category: "",
  source: "",
  contact_number: "",
  alternate_number: "",
  address: "",
  village: "",
  post: "",
  taluka: "",
  district: "",
  state: "",
  pincode: "",
  gst_no: "",
  payment_mode: "",
  payment_terms: "",
  order_poc: "",
  quotation_type: "",
  status: "", 
  valid_until: "",
  user: userId,
  company: "",
  email: "",      
  country: "",  
  items: [
    {
      product: "",
      serial_number: "",
      quantity: "",
      unit:""
    }
  ],
});
const [formErrors, setFormErrors] = useState({
  name: '',
  contact_number: '',
  address: '',
  email: '',
  gst_no: '',
  quotation_type: '',
  status: '',
  company: '',
  source: '',
  category: '',
  valid_until: '',
  village: '',
  country: '',
  state: '',
  district: '',
  taluka: '',
  post: '',
  pincode: '',
  order_poc: '',
  payment_mode: '',
  payment_terms: ''
});
  const [openDialog, setOpenDialog] = useState(false);
  const [formStep, setFormStep] = useState(0);
  const [quotationTypes, setQuotationTypes] = useState([]);
  const [paymentModeOptions, setPaymentModeOptions] = useState([]);
const [deliveryModeOptions, setDeliveryModeOptions] = useState([]);
const [sourceOptions, setSourceOptions] = useState([]);
const [categoryOptions, setCategoryOptions] = useState([]);
const [companyOptions, setCompanyOptions] = useState([]);
const [invoiceModal, setInvoiceModal] = useState({ open: false, invoice: null, order: null })
  const [deliveryChallanModal, setDeliveryChallanModal] = useState({ open: false, challan: null, order: null })
   const [downloadingInvoice, setDownloadingInvoice] = useState(false)
    const [downloadingChallan, setDownloadingChallan] = useState(false)
    const [savingQuotation, setSavingQuotation] = useState(false)
    const [savedProducts, setSavedProducts] = useState([]);
      const [actionsAnchorEl, setActionsAnchorEl] = useState(null)
      const [companyMismatchDialog, setCompanyMismatchDialog] = useState({
        open: false,
        pendingProduct: null,
        pendingRowIndex: null,
        pendingCompanyChange: null,
        existingCompany: null,
        newCompany: null
      });
      
  // ============ PERMISSION FUNCTIONS ============
  const getCurrentButtonPermissions = () => {
    const moduleConfig = buttonConfig["Quotation/Proforma Invoice"];
    return moduleConfig?.actions ?? moduleConfig ?? {};
  };
  
  const shouldEnableButton = (buttonKey) => {
    const permissions = getCurrentButtonPermissions();
    return permissions[buttonKey] === true;
  };
  // ============ END PERMISSION FUNCTIONS ============

  // Invoice and challan handling
const [measureUnits, setMeasureUnits] = useState([]);
const [productOptions, setProductOptions] = useState([]);
const [selectedOrders, setSelectedOrders] = useState([]);
const [countries, setCountries] = useState([]);
const [states, setStates] = useState([]);
const [districts, setDistricts] = useState([]);
const [talukas, setTalukas] = useState([]);
const [companyFilter, setCompanyFilter] = useState('');
  const isCompanyUser = apiService.isCompanyUser();

// Helper function to generate unique row IDs
const generateRowId = () => {
  return `row-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

// Helper function to add a product (used by both direct add and after confirmation)
const handleAddProduct = (productRow, rowIndex) => {
  // Save to local state
  setSavedProducts((prev) => [...prev, productRow]);

  // Remove this row from editable rows and add a new empty row
  const updatedRows = productRows.filter((_, i) => i !== rowIndex);
  // Auto-add a new empty row after successfully adding a product
  updatedRows.push({
    id: generateRowId(), // ensure unique ID
    company_id: "",
    category_id: "",
    categoryOptions: [],
    product_id: "",
    productOptions: [],
    quantity: "",
    unit_id: "",
  });
  setProductRows(updatedRows);
  showSuccess("Product added successfully!");
};

// Handle confirmation dialog - Yes (clear all and add new product or change company)
const handleConfirmCompanyChange = () => {
  const { pendingProduct, pendingRowIndex, pendingCompanyChange } = companyMismatchDialog;
  
  // Clear all existing products
  setSavedProducts([]);
  
  if (pendingProduct && pendingRowIndex !== null) {
    // Add the new product
    handleAddProduct(pendingProduct, pendingRowIndex);
  } else if (pendingCompanyChange !== null && pendingRowIndex !== null) {
    // Change company in the row
    const updatedRows = [...productRows];
    updatedRows[pendingRowIndex].company_id = pendingCompanyChange;
    updatedRows[pendingRowIndex].category_id = "";
    updatedRows[pendingRowIndex].categoryOptions = [];
    updatedRows[pendingRowIndex].product_id = "";
    updatedRows[pendingRowIndex].productOptions = [];
    setProductRows(updatedRows);
    fetchCategoriesByCompany(pendingCompanyChange, pendingRowIndex);
  }
  
  // Close the dialog
  setCompanyMismatchDialog({
    open: false,
    pendingProduct: null,
    pendingRowIndex: null,
    pendingCompanyChange: null,
    existingCompany: null,
    newCompany: null
  });
};

// Handle confirmation dialog - No (don't add product or change company)
const handleCancelCompanyChange = () => {
  setCompanyMismatchDialog({
    open: false,
    pendingProduct: null,
    pendingRowIndex: null,
    pendingCompanyChange: null,
    existingCompany: null,
    newCompany: null
  });
};

const [productRows, setProductRows] = useState([
  {
    id: generateRowId(),        // unique ID for each row
    company_id: "",        // selected company
    category_id: "",       // selected category
    product_id: "",        // selected product
    quantity: "",          // quantity input
    unit_id: "",           // selected measure unit
    categoryOptions: [],   // dropdown options for categories
    productOptions: [],    // dropdown options for products
  }
]);

  const isActionsMenuOpen = Boolean(actionsAnchorEl)
  const openActionsMenu = (e) => setActionsAnchorEl(e.currentTarget)
  const closeActionsMenu = () => setActionsAnchorEl(null)
 
  const [emailDialog, setEmailDialog] = useState({
    open: false,
    emails: '',
    sendInvoice: true,
    sendDelivery: true,
    isSending: false,
    error: '',
    success: '',
     orders: []
  })
    const closeSingleOrderEmail = () => {
    setSingleEmailDialog({
      open: false,
      order: null,
      emailInput: '',
      emails: [],
      sendInvoice: true,
      sendDelivery: true,
      isSending: false,
      error: '',
      success: ''
    })
  }
    const [singleEmailDialog, setSingleEmailDialog] = useState({
      open: false,
      order: null,
      emailInput: '',
      emails: [],
      sendInvoice: true,
      sendDelivery: true,
      isSending: false,
      error: '',
      success: ''
    })

    const handleOpenEmailDialog = (order = null) => {
  if (order) {
    // Single order email
    setSingleEmailDialog({
      open: true,
      order: order,
      emailInput: '',
      emails: [],
      sendInvoice: true,
      sendDelivery: true,
      isSending: false,
      error: '',
      success: ''
    });
  } else {
    // Bulk email (you'll need to implement selection logic)
    setEmailDialog(prev => ({ 
      ...prev, 
      open: true, 
      error: '', 
      success: '',
      orders: [] // You need to set selected orders here
    }));
  }
  closeActionsMenu();
}


  const handleCloseEmailDialog = () => {
    setEmailDialog({ open: false, emails: '', sendInvoice: true, sendDelivery: true, isSending: false, error: '', success: '' })
  }



const handleViewQuotationPdf = (order) => {
  if (order?.pdf_url) {
    window.open(order.pdf_url, "_blank", "noopener,noreferrer");
  } else {
    showError("Quotation PDF is not generated yet");
  }
};
const handleDownloadPDF = (pdfUrl, filename) => {
  if (!pdfUrl) {
    alert("PDF not available for download");
    return;
  }

  try {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = filename.replace(/[^a-zA-Z0-9]/g, "_") + ".pdf";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error("Error downloading PDF:", err);
    alert("Error downloading PDF. Please try again.");
  }
};


  const handleCloseInvoiceModal = () => {
    setInvoiceModal({ open: false, invoice: null, order: null })
  }

const handleViewProformaInvoice = (order) => {
  if (order?.proforma_invoice_pdf_url) {
    setInvoiceModal({
      open: true,
      url: order.proforma_invoice_pdf_url,
      title: "Proforma Invoice",
      order,
    });
  } else {
    showError("Proforma Invoice is not generated yet");
  }
};

  const handleDownloadDeliveryChallan = async (challan, orderName) => {
    if (!challan || !challan.path) {
      alert('Delivery challan not available for download')
      return
    }

    setDownloadingChallan(true)
    try {
      const link = document.createElement('a')
      link.href = challan.path
      link.download = `Delivery_Challan_${challan.id}_${orderName.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.error('Error downloading delivery challan:', error)
      alert('Error downloading delivery challan. Please try again.')
    } finally {
      setDownloadingChallan(false)
    }
  }

  const handleCloseDeliveryChallanModal = () => {
    setDeliveryChallanModal({ open: false, challan: null, order: null })
  }

  // Filter quotations based on company filter
  const filteredQuotations = useMemo(() => {
    if (!companyFilter) return quotations;
    
    return quotations.filter(quotation => 
      quotation.company_id === parseInt(companyFilter) || 
      quotation.company?.id === parseInt(companyFilter) ||
      quotation.company === parseInt(companyFilter)
    );
  }, [quotations, companyFilter]);

  useEffect(() => {
    if (openDialog) {
      setFormStep(0);
      const defaultQuotationType = quotationTypes[0]?.value || 'Quotation';
      setFormData((prev) => ({ ...prev, quotation_type: defaultQuotationType }));
    }
  }, [openDialog, quotationTypes]);

const GST_HIDDEN_CUSTOMER_TYPES = new Set([
  'farmer',
  'urban farmer',
  'panchayat samiti',
]);

const normalizeCustomerType = (value = '') =>
  String(value || '').trim().toLowerCase();

const isGstHiddenForCategory = (categoryValue = formData.category) => {
  const selectedOption = categoryOptions.find((option) =>
    [option?.value, option?.label, option?.name, option?.id]
      .map((value) => String(value ?? ''))
      .includes(String(categoryValue ?? ''))
  );

  return [categoryValue, selectedOption?.label, selectedOption?.name, selectedOption?.value]
    .some((value) => GST_HIDDEN_CUSTOMER_TYPES.has(normalizeCustomerType(value)));
};

const validateForm = () => {
  const shouldHideGst = isGstHiddenForCategory();
  const errors = {
    name: validateField('name', formData.name),
    contact_number: validateField('contact_number', formData.contact_number),
    address: validateField('address', formData.address),
    email: validateField('email', formData.email),
    gst_no: shouldHideGst ? '' : validateField('gst_no', formData.gst_no),
    quotation_type: validateField('quotation_type', formData.quotation_type),
    status: validateField('status', formData.status),
    source: validateField('source', formData.source),
    category: validateField('category', formData.category),
    valid_until: validateField('valid_until', formData.valid_until),
    village: validateField('village', formData.village),
    country: validateField('country', formData.country),
    state: validateField('state', formData.state),
    district: validateField('district', formData.district),
    taluka: validateField('taluka', formData.taluka),
    post: validateField('post', formData.post),
    pincode: validateField('pincode', formData.pincode),
    order_poc: validateField('order_poc', formData.order_poc),
    payment_mode: validateField('payment_mode', formData.payment_mode),
    payment_terms: validateField('payment_terms', formData.payment_terms),
  };

  setFormErrors(errors);

  // Check if all required fields are valid (all fields except alternate_number and gst_no)
  const requiredFields = [
    'name', 'contact_number', 'address', 'email',
    'quotation_type', 'status', 'source', 'category', 'valid_until',
    'village', 'country', 'state', 'district', 'taluka', 'post', 'pincode', 'order_poc',
    'payment_mode', 'payment_terms'
  ];
  
  const isValid = requiredFields.every(field => !errors[field]);
  
  // If not valid, show the first error message
  if (!isValid) {
    const firstErrorField = requiredFields.find(field => errors[field]);
    if (firstErrorField && errors[firstErrorField]) {
      showError(errors[firstErrorField]);
    }
  }
  
  return isValid;
};

const validateField = (fieldName, value) => {
  let error = '';

  switch (fieldName) {
    case 'name':
      if (!value?.trim()) {
        error = 'Customer Name is required';
      } else if (value.trim().length < 2) {
        error = 'Customer Name must be at least 2 characters long';
      } else if (!/^[A-Za-z\s]+$/.test(value.trim())) {
        error = 'Customer Name must contain only letters';
      }
      break;

    case 'contact_number':
      if (!value?.trim()) {
        error = 'Contact Number is required';
      } else if (!/^[0-9]{10}$/.test(value.replace(/\s/g, ''))) {
        error = 'Contact Number must be exactly 10 digits';
      }
      break;

    case 'address':
      if (!value?.trim()) {
        error = 'Address is required';
      } else if (value.trim().length < 10) {
        error = 'Address must be at least 10 characters long';
      }
      break;

    case 'email':
      if (!value?.trim()) {
        error = 'Email Address is required';
      } else if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value.trim())) {
        error = 'Please enter a valid email address';
      }
      break;

    case 'gst_no':
      if (isGstHiddenForCategory()) {
        break;
      }
      // GST is optional, but if provided, validate format
      if (value?.trim() && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value)) {
        error = 'Please enter a valid GST number (15 characters)';
      }
      break;

    case 'quotation_type':
      if (!value?.trim()) {
        error = 'Document Type is required';
      }
      break;

    case 'status':
      if (!value?.trim()) {
        error = 'Status is required';
      }
      break;

    case 'company':
      if (!value?.trim() && !formData.company_id?.toString().trim()) {
        error = 'Company is required';
      }
      break;

    case 'source':
      if (!value?.trim()) {
        error = 'Source is required';
      }
      break;

    case 'category':
      if (!value?.trim()) {
        error = 'Category is required';
      }
      break;

    case 'valid_until':
      if (!value?.trim()) {
        error = 'Valid Until date is required';
      }
      break;

    case 'village':
      if (!value?.trim()) {
        error = 'Village is required';
      }
      break;

    case 'country':
      if (!value?.trim()) {
        error = 'Country is required';
      }
      break;

    case 'state':
      if (!value?.trim()) {
        error = 'State is required';
      }
      break;

    case 'district':
      if (!value?.trim()) {
        error = 'District is required';
      }
      break;

    case 'taluka':
      if (!value?.trim()) {
        error = 'Taluka is required';
      }
      break;

    case 'post':
      if (!value?.trim()) {
        error = 'Post is required';
      }
      break;

    case 'pincode':
      if (!value?.trim()) {
        error = 'Pincode is required';
      } else if (!/^[1-9][0-9]{5}$/.test(value.trim())) {
        error = 'Invalid pincode. It should be a 6-digit number.';
      }
      break;

    case 'order_poc':
      if (!value?.trim()) {
        error = 'Executive Name is required';
      }
      break;

    case 'payment_mode':
      if (!value?.trim()) {
        error = 'Payment Mode is required';
      }
      break;

    case 'payment_terms':
      if (!value?.trim()) {
        error = 'Payment Terms is required';
      }
      break;

    default:
      break;
  }

  return error;
};

const stepFieldMap = [
  ['quotation_type', 'status'],
  ['name', 'contact_number', 'email', 'source', 'category', 'valid_until'],
  ['address', 'village', 'country', 'state', 'district', 'taluka', 'post', 'pincode', 'order_poc'],
  [],
  ['payment_mode', 'payment_terms'],
];

const totalFormSteps = stepFieldMap.length;

const validateStep = (step) => {
  if (step === 3) {
    if (savedProducts.length === 0) {
      showError('Please add at least one product before proceeding');
      return false;
    }
    return true;
  }

  const fields = stepFieldMap[step] || [];
  if (fields.length === 0) return true;

  const nextErrors = {};
  fields.forEach((field) => {
    nextErrors[field] = validateField(field, formData[field]);
  });

  setFormErrors((prev) => ({ ...prev, ...nextErrors }));

  const firstErrorField = fields.find((field) => nextErrors[field]);
  if (firstErrorField) {
    showError(nextErrors[firstErrorField]);
    return false;
  }

  return true;
};

const handleNextStep = () => {
  if (!validateStep(formStep)) return;
  setFormStep((prev) => Math.min(prev + 1, totalFormSteps - 1));
};

const handlePreviousStep = () => {
  setFormStep((prev) => Math.max(prev - 1, 0));
};

// Update form data with validation
const handleFormDataChange = (field, value) => {
  setFormData(prev => ({
    ...prev,
    [field]: value,
    ...(field === 'category' && isGstHiddenForCategory(value) ? { gst_no: '' } : {}),
  }));
  
  // Validate the field in real-time
  const error = validateField(field, value);
  setFormErrors(prev => ({
    ...prev,
    [field]: error,
    ...(field === 'category' && isGstHiddenForCategory(value) ? { gst_no: '' } : {}),
  }));
};

  const fetchQuotations = async (companyId = null, page = 1, pageSizeParam = 10) => {
    setLoadingQuo(true);
    try {
      let url = API_ENDPOINTS.GET_quotations;
      const params = new URLSearchParams();
      params.set('page', String(page));
      params.set('page_size', String(pageSizeParam));
      if (companyId) {
        params.set('company_id', companyId);
      }
      url += (url.includes('?') ? '&' : '?') + params.toString();
      
      const res = await apiService.get(url);
      
      const data = Array.isArray(res?.data?.data?.Quotation) 
        ? res.data.data.Quotation 
        : Array.isArray(res?.data?.Quotation) 
          ? res.data.Quotation 
          : [];
      
      setQuotations(data);
      const paginationData = res?.pagination || res?.data?.pagination || {};
      if (Object.keys(paginationData).length > 0) {
        setPagination({
          current_page: paginationData.current_page ?? page,
          page_size: paginationData.page_size ?? pageSizeParam,
          total_items: paginationData.total_items ?? 0,
          total_pages: paginationData.total_pages ?? 1,
          has_next: paginationData.has_next ?? false,
          has_previous: paginationData.has_previous ?? false,
          next_page_number: paginationData.next_page_number ?? null,
          previous_page_number: paginationData.previous_page_number ?? null,
        });
        setCurrentPage(paginationData.current_page ?? page);
        setPageSize(paginationData.page_size ?? pageSizeParam);
      } else {
        setPagination(prev => ({
          ...prev,
          total_items: data.length,
          total_pages: 1,
          current_page: 1,
          page_size: pageSizeParam,
        }));
      }
    } catch (err) {
      if (!navigator.onLine) {
    showError("No network connection - offline mode active");
  } else 
      showError(typeof err === 'string' ? err : err?.message || 'Failed to load quotations');
    } finally {
      setLoadingQuo(false);
    }
  };

  const handleQuotationPageChange = (_, value) => {
    setCurrentPage(value);
    fetchQuotations(companyFilter || null, value, pageSize);
  };

  const handleQuotationPageSizeChange = (e) => {
    const newSize = Number(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);
    fetchQuotations(companyFilter || null, 1, newSize);
  };

  // Fetch dashboard data for total quotations
  const fetchDashboardData = async () => {
    setLoadingDashboard(true);
    try {
      const response = await dedupedGet(API_ENDPOINTS.GET_quotation_dashboard);
      if (response?.success && response?.data?.summary) {
        setTotalQuotations(response.data.summary.total_quotations);
      } else {
        setTotalQuotations(null);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      setTotalQuotations(null);
    } finally {
      setLoadingDashboard(false);
    }
  };

const fetchQuotationTypes = async () => {
  try {
    const res = await dedupedGet(API_ENDPOINTS.GET_quotation_type_choices);
    console.log("API Response:", res?.data);

    const options =
      res?.data?.data ||       
      res?.data?.choices ||    
      res?.data ||             
      [];

    if (Array.isArray(options)) {
      const quotationOnly = options.filter((opt) => {
        const label = String(opt?.label ?? opt?.value ?? '').toLowerCase().trim();
        return label === 'quotation';
      });
      setQuotationTypes(quotationOnly);
      const defaultValue = quotationOnly[0]?.value || 'Quotation';
      setFormData((prev) => ({ ...prev, quotation_type: defaultValue }));
    } else {
      console.error("Unexpected response format", res?.data);
    }
  } catch (error) {
    console.error("Failed to fetch quotation types:", error);
  }
};

const fetchStatusOptions = async () => {
  try {
    const res = await dedupedGet(API_ENDPOINTS.GET_status_choices);
    console.log("Status API response:", res?.data);
    const options =    res?.data?.data ||       
      res?.data?.choices ||    
      res?.data ||   [];
    console.log("Extracted options:", options);
    if (Array.isArray(options)) setStatusOptions(options);
  } catch (err) {
    console.error("Failed to fetch status options:", err);
  }
};

const handleDirectDownloadPDF = async (pdfUrl, filename) => {
  if (!pdfUrl) {
    alert("PDF not available for download");
    return;
  }

  try {
    setDownloadingInvoice(true); 
    const response = await fetch(pdfUrl, {
      method: "GET",
      headers: {
      },
    });

    if (!response.ok) throw new Error("Failed to fetch PDF");

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename.replace(/[^a-zA-Z0-9]/g, "_") + ".pdf";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error("Error downloading PDF:", err);
    alert("Error downloading PDF. Please try again.");
  } finally {
    setDownloadingInvoice(false);
  }
};



const fetchPaymentModeOptions = async () => {
  try {
    const res = await dedupedGet(API_ENDPOINTS.GET_payment_mode_choices);
    const options =  res?.data?.data ||       
      res?.data?.choices ||    
      res?.data || [];
    if (Array.isArray(options)) setPaymentModeOptions(options);
  } catch (err) {
    console.error("Failed to fetch payment modes:", err);
  }
};

const fetchDeliveryModeOptions = async () => {
  try {
    const res = await dedupedGet(API_ENDPOINTS.GET_delivery_mode_choices);
    const options =  res?.data?.data ||       
      res?.data?.choices ||    
      res?.data || [];
    if (Array.isArray(options)) setDeliveryModeOptions(options);
  } catch (err) {
    console.error("Failed to fetch delivery modes:", err);
  }
};

const fetchSourceOptions = async () => {
  try {
    const res = await dedupedGet(API_ENDPOINTS.GET_source_choices);
    const options = res?.data?.data || res?.data?.choices || res?.data || [];

    if (Array.isArray(options)) {
      setSourceOptions(options);
      setFormData(prev => ({
        ...prev,
        source: prev.source || options[0]?.value || ""
      }));
    }
  } catch (err) {
    console.error("Failed to fetch source options:", err);
  }
};

const fetchCategoryOptions = async () => {
  try {
    const res = await dedupedGet(API_ENDPOINTS.GET_category_choices);
    const options = res?.data?.data || res?.data?.choices || res?.data || [];

    if (Array.isArray(options)) {
      setCategoryOptions(options);
      setFormData(prev => ({
        ...prev,
        category: prev.category || options[0]?.value || ""
      }));
    }
  } catch (err) {
    console.error("Failed to fetch category options:", err);
  }
};


const fetchCompanies = async () => {
  try {
    if (isCompanyUser) {
      const details = apiService.getCompanyDetails();
      const id = apiService.getCompanyId();

      const singleCompany = {
        id: id,
        name: details?.name || "My Company",
      };

      setCompanyOptions([singleCompany]);
      setFormData(prev => ({
        ...prev,
        company_id: id, 
      }));

      return; 
    }

    const res = await dedupedGet(API_ENDPOINTS.GET_company_choices);
    const options = res?.data?.Company || res?.data?.choices || res?.data || [];

    if (Array.isArray(options)) {
      setCompanyOptions(options);

      setFormData(prev => ({
        ...prev,
        company_id: prev.company_id || "", 
      }));
    }
  } catch (err) {
    console.error("Failed to fetch company options:", err);
  }
};



const fetchCategoriesByCompany = async (companyId, rowIndex) => {
  if (!companyId) return;

  try {
    const res = await apiService.get(
      `${API_ENDPOINTS.GET_product_category}?company=${companyId}`
    );

    const categories = res?.data?.ProductCategory || [];
    const options = categories.map(cat => ({
      id: cat.id,
      name: cat.name
    }));

    setProductRows(prevRows => {
      const updated = [...prevRows];
      updated[rowIndex].categoryOptions = options;
      return updated;
    });
  } catch (err) {
    console.error("Failed to fetch categories:", err);
  }
};

const fetchProductsByCompanyAndCategory = async (companyId, categoryId, rowIndex) => {
  if (!companyId || !categoryId) return;
  try {
    const res = await apiService.get(
      `${API_ENDPOINTS.GET_product_by_company_and_category_filter}?company=${companyId}&category=${categoryId}`
    );
    const products = res?.data?.Product || [];

    setProductRows(prevRows => {
      const updated = [...prevRows];
      updated[rowIndex].productOptions = products;
      return updated;
    });
  } catch (err) {
    console.error("Failed to fetch products:", err);
    setProductRows(prevRows => {
      const updated = [...prevRows];
      updated[rowIndex].productOptions = [];
      return updated;
    });
  }
};

const fetchMeasureUnits = async () => {
  try {
    const res = await dedupedGet(API_ENDPOINTS.GET_measure_units);
    console.log("Measure Units API response:", res?.data);

    const options = res?.data?.MeasureUnits || res?.data || [];
    if (Array.isArray(options)) {
      setMeasureUnits(options);
    } else {
      console.error("Unexpected MeasureUnits format:", options);
    }
  } catch (err) {
    console.error("Failed to fetch measure units:", err);
  }
};

const fetchCountries = async () => {
  try {
    const res = await dedupedGet(API_ENDPOINTS.GET_COUNTRIES);
    console.log("Countries API response:", res?.data);

    const options = res?.data || [];
    if (Array.isArray(options)) {
      setCountries(options);
    } else {
      console.error("Unexpected countries format:", options);
    }
  } catch (err) {
    console.error("Failed to fetch countries:", err);
  }
};

const fetchStates = async (countryName) => {
  if (!countryName) return; 
  try {
    const res = await dedupedGet(`${API_ENDPOINTS.GET_STATES}?country_name=${countryName}`);
    console.log("States API response:", res?.data);

    const options = res?.data || [];
    if (Array.isArray(options)) {
      setStates(options);
    } else {
      console.error("Unexpected states format:", options);
    }
  } catch (err) {
    console.error("Failed to fetch states:", err);
  }
};

const fetchDistricts = async (stateName) => {
  if (!stateName) return; 
  try {
    const res = await dedupedGet(`${API_ENDPOINTS.GET_DISTRICTS}?state=${stateName}`);
    console.log("Districts API response:", res?.data);

    const options = res?.data?.District || [];
    if (Array.isArray(options)) {
      setDistricts(options);
    } else {
      console.error("Unexpected districts format:", options);
    }
  } catch (err) {
    console.error("Failed to fetch districts:", err);
  }
};

const fetchTalukas = async (districtName) => {
  if (!districtName) return; 
  try {
    const res = await dedupedGet(`${API_ENDPOINTS.GET_TALUKA}?district=${districtName}`);
    console.log("Talukas API response:", res?.data);

    const options = res?.data?.Taluka || [];
    if (Array.isArray(options)) {
      setTalukas(options);
    } else {
      console.error("Unexpected talukas format:", options);
    }
  } catch (err) {
    console.error("Failed to fetch talukas:", err);
  }
};


useEffect(() => {
  fetchQuotationTypes();
  fetchStatusOptions();
  fetchPaymentModeOptions();
  fetchDeliveryModeOptions();
  fetchSourceOptions();
  fetchCategoryOptions();
  fetchCompanies();
  fetchCategoriesByCompany();
  fetchProductsByCompanyAndCategory();
  fetchMeasureUnits();
  fetchCountries();
  fetchStates();
  fetchDistricts();
  fetchTalukas();
  fetchDashboardData();
}, []);

  useEffect(() => {
    if (invoiceModal.open && !invoiceModal.url) {
      setInvoiceModal({
        open: false,
        url: null,
        title: "",
        order: null
      });
    }
  
  }, [invoiceModal.open, invoiceModal.url]);
  

  useEffect(() => {
    fetchQuotations(companyFilter || null, currentPage, pageSize);
  }, [companyFilter]);

  const handleCompanyFilterChange = (e) => {
    const companyId = e.target.value;
    setCompanyFilter(companyId);
  };

  const handleClearFilter = () => {
    setCompanyFilter('');
    fetchQuotations(companyFilter || null, currentPage, pageSize); 
  };

const submitSingleOrderEmail = async () => {
  const { order, emails, sendInvoice, sendDelivery } = singleEmailDialog;
  
  if (!order) {
    setSingleEmailDialog(prev => ({ ...prev, error: 'No order selected' }));
    return;
  }
  
  if (emails.length === 0) {
    setSingleEmailDialog(prev => ({ ...prev, error: 'Please add at least one email' }));
    return;
  }
  
  if (!sendInvoice && !sendDelivery) {
    setSingleEmailDialog(prev => ({ ...prev, error: 'Please select at least one document type' }));
    return;
  }

  setSingleEmailDialog(prev => ({ ...prev, isSending: true, error: '', success: '' }));

  try {
    const userId = localStorage.getItem('user_id');
    const payload = {
      emails: emails.join(','),
      send_invoice: sendInvoice,
      send_quotation: sendDelivery,
      quotation_id: order.id,
      user_id: userId
    };

    console.log('Sending email with payload:', payload);

    const res = await apiService.post(
      API_ENDPOINTS.POST_send_quotation,
      payload 
    );

    console.log('Email API response:', res);
if (res?.status === 200 && res?.data?.message?.includes('successfully')) {
  setSingleEmailDialog(prev => ({ 
    ...prev, 
    success: res.data.message, 
    isSending: false 
  }));
  setTimeout(() => closeSingleOrderEmail(), 1200);
} else {
  throw new Error(res?.data?.message || 'Failed to send email');
}

  } catch (err) {
    console.error('Email sending error:', err);
    setSingleEmailDialog(prev => ({ 
      ...prev, 
      error: err?.response?.data?.message || err?.message || 'Failed to send email', 
      isSending: false 
    }));
  }
};


const handleEmailSendSubmit = async () => {
  const { emails, sendInvoice, sendDelivery, orders } = emailDialog;

  const trimmed = (emails || '').split(/[,\s]+/).map(e => e.trim()).filter(Boolean);
  if (trimmed.length === 0) {
    setEmailDialog(prev => ({ ...prev, error: 'Please enter at least one email address' }));
    return;
  }
  if (!sendInvoice && !sendDelivery) {
    setEmailDialog(prev => ({ ...prev, error: 'Please select at least one document type to send' }));
    return;
  }
  if (!orders || orders.length === 0) {
    setEmailDialog(prev => ({ ...prev, error: 'No orders selected to send' }));
    return;
  }

  setEmailDialog(prev => ({ ...prev, isSending: true, error: '', success: '' }));

  try {
    const userId = localStorage.getItem('user_id');
    const payload = {
      emails: trimmed.join(','),
      send_invoice: sendInvoice,
      send_delivery: sendDelivery,
      order_ids: orders.map(o => o.id),
      user_id: userId
    };

    const res = await apiService.post(
      API_ENDPOINTS.POST_send_quotation,
      payload 
    );

    if (res?.success) {
      setEmailDialog(prev => ({ ...prev, success: 'Email sent successfully', isSending: false }));
      setTimeout(() => handleCloseEmailDialog(), 1200);
    } else {
      throw new Error(res?.message || 'Failed to send email');
    }
  } catch (err) {
    setEmailDialog(prev => ({ 
      ...prev, 
      error: err?.response?.data?.message || err?.message || 'Failed to send email', 
      isSending: false 
    }));
  }
};

  const addEmailToSingle = () => {
    const input = (singleEmailDialog.emailInput || '').trim()
    if (!input) return
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(input)) {
      setSingleEmailDialog(prev => ({ ...prev, error: 'Enter a valid email address' }))
      return
    }
    if (singleEmailDialog.emails.includes(input)) {
      setSingleEmailDialog(prev => ({ ...prev, error: 'Email already added' }))
      return
    }
    setSingleEmailDialog(prev => ({ ...prev, emails: [...prev.emails, input], emailInput: '', error: '' }))
  }
    const removeEmailFromSingle = (email) => {
    setSingleEmailDialog(prev => ({ ...prev, emails: prev.emails.filter(e => e !== email) }))
  }

  return (
    <Box sx={{padding:"16px"}}>

<TableCard sx={{ mb: 2 }}>
<Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    alignItems: { xs: "stretch", md: "center" },
    gap: 2,
    flexWrap: "wrap",
  }}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 2,
    }}
  >
    <Typography variant="body2" fontWeight={600}>
      Filter by category:
    </Typography>

    <TextField
      select
      size="small"
      label="All Category"
      value={companyFilter}
      onChange={handleCompanyFilterChange}
      disabled={loadingQuo}
      sx={{ minWidth: { xs: "100%", sm: 250 } }}
    >
      <MenuItem value="">All Category</MenuItem>
      {companyOptions.map((company) => (
        <MenuItem key={company.id} value={company.id}>
          {company.name}
        </MenuItem>
      ))}
    </TextField>

    {totalQuotations !== null && (
      <Box
                        sx={{
                        minWidth: { xs: "100%", sm: 250 },
                        height: "40px",
                        display: "flex",
                        alignItems: "center",     
                        paddingLeft:  "10px",
                        backgroundColor: (theme) =>
                            theme.palette.mode === "dark"
                            ? "rgba(255, 255, 255, 0.05)"
                            : "rgba(0, 0, 0, 0.02)",
                        borderRadius: 1,
                        border: (theme) =>
                            `1px solid ${
                            theme.palette.mode === "dark"
                                ? "rgba(255, 255, 255, 0.23)"
                                : "rgba(0, 0, 0, 0.23)"
                            }`,
                        }}
                    >
        <Typography
                        variant="body1"
                        color="text.primary"
                        >
          Total Quotations:  {totalQuotations.toLocaleString()}

        </Typography>
      </Box>
    )}

  </Box>

  <Box
  sx={{
    display: "flex",
    justifyContent: { xs: "stretch", md: "flex-end" },
  }}
>
  <Button
  variant="contained"
  startIcon={<Add />}
  fullWidth={true}
  onClick={() => shouldEnableButton('create_quotation_proforma') && setOpenDialog(true)}
  disabled={!shouldEnableButton('create_quotation_proforma')}
  sx={{ 
    opacity: !shouldEnableButton('create_quotation_proforma') ? 0.6 : 1,
    height: "40px",
    width: "100%",
    fontSize: "14px",
    px: 4,
    ml: 40 // moved slightly to the right
  }}
>
  Create Quotation
</Button>
</Box>
  <FormControl size="small" sx={{ minWidth: 150 }}>
  <InputLabel>Rows</InputLabel>
  <Select value={pageSize} label="Rows" onChange={handleQuotationPageSizeChange}>
    {pageSizeOptions.map((opt) => (
      <MenuItem key={opt} value={opt}>{opt}</MenuItem>
    ))}
  </Select>
</FormControl>
<Button
  startIcon={<Refresh />}
  variant="contained"
  onClick={() => fetchQuotations(companyFilter || null, 1, pageSize)}
  disabled={loadingQuo}
  sx={{ ml: -1  }} // moved slightly to the left
>
  {loadingQuo ? 'Refreshing...' : 'Refresh'}
</Button>
</Box>
</TableCard>



<TableContainer component={Paper} sx={{ mt: 4, maxHeight: 780, overflow: "auto", padding: "0px 0px 20px 0px", 
  scrollbarWidth: "thin",
            scrollbarColor:
              theme.palette.mode === "dark"
                ? "#555 #1e1e1e"
                : "#c1c1c1 #f1f1f1",

            "&::-webkit-scrollbar": {
              height: 8,
              width: 8,
            },
            "&::-webkit-scrollbar-track": {
              background:
                theme.palette.mode === "dark"
                  ? "#1e1e1e"
                  : "#f1f1f1",
              borderRadius: 8,
            },
            "&::-webkit-scrollbar-thumb": {
              background:
                theme.palette.mode === "dark"
                  ? "#555"
                  : "#c1c1c1",
              borderRadius: 8,
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background:
                theme.palette.mode === "dark"
                  ? "#777"
                  : "#a8a8a8",
            }, }}>
  <Table stickyHeader>
    <TableHead sx={{ position: "sticky", top: 0, zIndex: 20 }}>
      <TableRow sx={{ backgroundColor: (theme) => theme.palette.grey[200] }}>
        <TableCell sx={{ width: 50, backgroundColor: (theme) => theme.palette.grey[200] }} style={{padding:"16px"}}>Sr. No.</TableCell>
        <TableCell sx={{ width: 120, backgroundColor: (theme) => theme.palette.grey[200] }}>Quotation No</TableCell>
        <TableCell sx={{ width: 120, backgroundColor: (theme) => theme.palette.grey[200] }}>Company</TableCell>
        <TableCell sx={{ width: 100, backgroundColor: (theme) => theme.palette.grey[200] }}>Name</TableCell>
        <TableCell sx={{ width: 100, backgroundColor: (theme) => theme.palette.grey[200] }}>Category</TableCell>
        <TableCell sx={{ width: 100, backgroundColor: (theme) => theme.palette.grey[200] }}>Source</TableCell>
        <TableCell sx={{ width: 120, backgroundColor: (theme) => theme.palette.grey[200] }}>Alternate No</TableCell>
        <TableCell sx={{ width: 150, backgroundColor: (theme) => theme.palette.grey[200] }}>Address</TableCell>
        <TableCell sx={{ width: 100, backgroundColor: (theme) => theme.palette.grey[200] }}>Village</TableCell>
        <TableCell sx={{ width: 100, backgroundColor: (theme) => theme.palette.grey[200] }}>Post</TableCell>
        <TableCell sx={{ width: 100, backgroundColor: (theme) => theme.palette.grey[200] }}>Taluka</TableCell>
        <TableCell sx={{ width: 100, backgroundColor: (theme) => theme.palette.grey[200] }}>District</TableCell>
        <TableCell sx={{ width: 100, backgroundColor: (theme) => theme.palette.grey[200] }}>State</TableCell>
        <TableCell sx={{ width: 100, backgroundColor: (theme) => theme.palette.grey[200] }}>Pincode</TableCell>
        <TableCell sx={{ width: 120, backgroundColor: (theme) => theme.palette.grey[200] }}>GST No</TableCell>
        <TableCell sx={{ width: 120, backgroundColor: (theme) => theme.palette.grey[200] }}>Payment Mode</TableCell>
        <TableCell sx={{ width: 120, backgroundColor: (theme) => theme.palette.grey[200] }}>Payment Terms</TableCell>
        <TableCell sx={{ width: 120, backgroundColor: (theme) => theme.palette.grey[200] }}>Delivery Terms</TableCell>
        <TableCell sx={{
          position: "sticky",
          right: 0,
          top: 0,
          zIndex: 21,
          backgroundColor: (theme) => theme.palette.grey[200],
          width: 150,
        }}>Actions</TableCell>
      </TableRow>
    </TableHead>

    <TableBody>
      {loadingQuo ? (
        <TableRow>
          <TableCell colSpan={19} align="center">
            <CircularProgress size={28} />
          </TableCell>
        </TableRow>
      ) : quotations.length === 0 ? (
        <TableRow>
          <TableCell colSpan={19} align="center">
            No quotations found.
          </TableCell>
        </TableRow>
      ) : (
        quotations.map((q, index) => {
          const isOpen = openRow === q.id;
          return (
            <>
     <Fragment key={q.id}>
  {/* MAIN ROW */}
  <TableRow hover>
    <TableCell sx={{ width: 50 }} style={{padding:"16px"}}>
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      {(currentPage - 1) * pageSize + index + 1}
    </Typography>
    </TableCell>
    <TableCell>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <IconButton size="small" onClick={() => setOpenRow(isOpen ? null : q.id)}>
          {isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </IconButton>
        <Typography
          variant="body2"
          fontWeight={600}
          sx={{
            color: (theme) => theme.palette.mode === 'dark' ? '#fff' : '#145238',
          }}
        >
          {q.quotation_number || `QUT-${q.id}`}
        </Typography>
      </Box>

    </TableCell>
    <TableCell>
      <Tooltip title={q.company.name || ''} arrow>
        <Typography 
          variant="body2" 
          sx={{ 
            maxWidth: 120, 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            whiteSpace: 'nowrap',
            cursor: 'help'
          }}
        >
          {q.company.name}
        </Typography>
      </Tooltip>
    </TableCell>
    <TableCell>
      <Tooltip title={q.name || ''} arrow>
        <Box sx={{ maxWidth: 140, cursor: 'help' }}>
          <Typography 
            variant="body2" 
            sx={{ 
              overflow: 'hidden', 
              textOverflow: 'ellipsis', 
              whiteSpace: 'nowrap'
            }}
          >
            {q.name}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              display: 'block',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {q.contact_number || '-'}
          </Typography>
        </Box>
      </Tooltip>
    </TableCell>
    <TableCell>
      <Chip 
        label={q.category || 'N/A'} 
        size="small" 
        color="info"
        variant="outlined"
      />
    </TableCell>
    <TableCell>
      <Chip 
        label={q.source || 'N/A'} 
        size="small" 
        color="secondary"
        variant="outlined"
      />
    </TableCell>
    <TableCell>{q.alternate_number || '-'}</TableCell>
    <TableCell>
      <Tooltip title={q.address || ''} arrow>
        <Typography 
          variant="body2" 
          sx={{ 
            maxWidth: 150, 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            whiteSpace: 'nowrap',
            cursor: 'help'
          }}
        >
          {q.address}
        </Typography>
      </Tooltip>
    </TableCell>
     <TableCell>
      <Tooltip title={q.address || ''} arrow>
        <Typography 
          variant="body2" 
          sx={{ 
            maxWidth: 150, 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            whiteSpace: 'nowrap',
            cursor: 'help'
          }}
        >
          {q.village}
        </Typography>
      </Tooltip>
    </TableCell>
     <TableCell>
      <Tooltip title={q.address || ''} arrow>
        <Typography 
          variant="body2" 
          sx={{ 
            maxWidth: 150, 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            whiteSpace: 'nowrap',
            cursor: 'help'
          }}
        >
          {q.post}
        </Typography>
      </Tooltip>
    </TableCell>
     <TableCell>
      <Tooltip title={q.address || ''} arrow>
        <Typography 
          variant="body2" 
          sx={{ 
            maxWidth: 150, 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            whiteSpace: 'nowrap',
            cursor: 'help'
          }}
        >
          {q.taluka}
        </Typography>
      </Tooltip>
    </TableCell>
    <TableCell>{q.district}</TableCell>
    <TableCell>{q.state}</TableCell>
    <TableCell>{q.pincode}</TableCell>
    <TableCell>{q.gst_no || '-'}</TableCell>
    <TableCell>
      <Chip 
        label={q.payment_mode || 'N/A'} 
        size="small" 
        color="success"
        variant="outlined"
      />
    </TableCell>
    <TableCell>{q.payment_terms || '-'}</TableCell>
    <TableCell>{q.delivery_terms || '-'}</TableCell>
     <TableCell sx={(theme) => ({
   position: "sticky",
   right: 0,
   zIndex: 4,
   backgroundColor: theme.palette.background.paper, 
   display: "flex", 
   gap: 1,
   minWidth: 150,
   padding:"50px 20px"
 })}>
  {q.pdf_url && (
    <Tooltip title="View Quotation PDF">
      <span>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            if (shouldEnableButton('view_quotation_pdf')) {
              handleViewQuotationPdf(q);
            }
          }}
          disabled={!shouldEnableButton('view_quotation_pdf')}
          color="primary"
          sx={{ opacity: !shouldEnableButton('view_quotation_pdf') ? 0.5 : 1 }}
        >
          <ReceiptIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  )}

  {q.proforma_invoice_pdf_url && (
    <Tooltip title="View Proforma Invoice">
      <span>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            if (shouldEnableButton('view_proforma_invoice')) {
              handleViewProformaInvoice(q);
            }
          }}
          disabled={!shouldEnableButton('view_proforma_invoice')}
          color="secondary"
          sx={{ opacity: !shouldEnableButton('view_proforma_invoice') ? 0.5 : 1 }}
        >
          <ChallanIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  )}

  <Tooltip title={!shouldEnableButton('send_email') ? "You don't have permission to send email" : "Send Email"}>
    <span>
      <IconButton
        size="small"
        color="primary"
        onClick={(e) => {
          e.stopPropagation();
          if (shouldEnableButton('send_email')) {
            handleOpenEmailDialog(q);
          }
        }}
        disabled={!shouldEnableButton('send_email')}
        sx={{ opacity: !shouldEnableButton('send_email') ? 0.5 : 1 }}
      >
        <EmailIcon fontSize="small" />
      </IconButton>
    </span>
  </Tooltip>

</TableCell>

  </TableRow>

<TableRow>
  <TableCell colSpan={19} sx={{ p: 0, border: 0 }}>
    <Collapse in={isOpen} timeout="auto" unmountOnExit>
      <Card
        sx={(theme) => ({
          m: 1,
          p: 2,
          backgroundColor:
            theme.palette.mode === 'dark'
              ? theme.palette.background.paper
              : '#ffffff',
          boxShadow:
            theme.palette.mode === 'dark'
              ? '0 2px 6px rgba(0,0,0,0.4)'
              : '0 2px 6px rgba(0,0,0,0.1)',
          borderRadius: 2,
        })}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <ShoppingCart sx={{ mr: 1, color: theme.palette.primary.main }} />
            <Typography variant="h6" fontWeight={600}>
              Quotation Details - {q.quotation_number || `QUT-${q.id}`}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Chip 
              label={q.quotation_type || 'N/A'} 
              color="primary" 
              variant="outlined"
            />
            <Chip 
              label={q.status || 'N/A'} 
              color={q.status === 'Accepted' ? 'success' : q.status === 'Sent' ? 'info' : 'default'}
              variant="outlined"
            />
          </Box>
        </Box>

        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Product</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>HSN Code</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Lot No</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Expiry Date</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Quantity</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>UOM</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Rate</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Total Value</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>CGST %</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>CGST Value</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>SGST %</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>SGST Value</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>IGST %</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>IGST Value</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Total With GST</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Order Value</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Amount In Words</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Executive Name</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {q.items.map((item, index) => (
              <TableRow
                key={index}
                sx={{
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.primary.main, 0.04),
                  },
                }}
              >
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>
                    {item.product_name}
                  </Typography>
                </TableCell>
                <TableCell>{item.hsn_code || '-'}</TableCell>
                <TableCell>{item.lot_no || '-'}</TableCell>
                <TableCell>{item.expiry_date ? new Date(item.expiry_date).toLocaleDateString() : '-'}</TableCell>
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>
                    {item.quantity}
                  </Typography>
                </TableCell>
                <TableCell>{item.unit_of_measure}</TableCell>
                <TableCell>₹{item.rate}</TableCell>
                <TableCell>₹{item.total_value}</TableCell>
                <TableCell>{item.cgst_percentage}%</TableCell>
                <TableCell>₹{item.cgst_value}</TableCell>
                <TableCell>{item.sgst_percentage}%</TableCell>
                <TableCell>₹{item.sgst_value}</TableCell>
                <TableCell>{item.igst_percentage}%</TableCell>
                <TableCell>₹{item.igst_value}</TableCell>
                <TableCell>
                  <Typography variant="body2" fontWeight={600} color="primary">
                    ₹{item.total_value_with_gst}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" fontWeight={600} color="success.main">
                    ₹{q.total_amount}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="caption" sx={{ fontStyle: 'italic' }}>
                    {q.amount_in_words}
                  </Typography>
                </TableCell>
                <TableCell>{q.order_poc || '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Divider sx={{ my: 2 }} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography variant="body2" color="text.secondary">
              <strong>Quotation Date:</strong> {new Date(q.quotation_date || q.created_at).toLocaleDateString()}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>Valid Until:</strong> {q.valid_until ? new Date(q.valid_until).toLocaleDateString() : 'N/A'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>Created By:</strong> {q.user_name || 'N/A'}
            </Typography>
          </Box>
          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="body2" color="text.secondary">
              <strong>Total Items:</strong> {q.items.length}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>Subtotal:</strong> ₹{q.subtotal}
            </Typography>
            <Typography variant="h6" color="primary" fontWeight={600}>
              <strong>Total Amount:</strong> ₹{q.total_amount}
            </Typography>
          </Box>
        </Box>
      </Card>
    </Collapse>
  </TableCell>
</TableRow>



</Fragment>

            </>
          );
        })
      )}
    </TableBody>
  </Table>
</TableContainer>

  <AppPaginationBar
    pagination={pagination}
    pageSize={pageSize}
    onPageChange={handleQuotationPageChange}
    itemLabel="quotations"
  />

<Dialog
  open={openDialog}
  onClose={() => setOpenDialog(false)}
  fullScreen={isMobileDialog}
  maxWidth={false}
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: 3,
      width: { xs: "100%", sm: "94vw", md: "min(960px, 92vw)" },
      maxWidth: "960px",
      minHeight: "auto",
      maxHeight: { xs: "100vh", sm: "90vh" },
      display: "flex",
      flexDirection: "column",
      boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
      m: { xs: 0, sm: 1.5, md: 2 },
    },
  }}
>
  <DialogTitle sx={{ 
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    color: theme.palette.primary.contrastText,
    py: { xs: 2, md: 2.5 },
    px: { xs: 2, sm: 3, md: 4 }
  }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Box sx={{ 
          p: 1.5, 
          borderRadius: 2, 
          backgroundColor: alpha(theme.palette.common.white, 0.1),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <AddIcon sx={{ fontSize: 28 }} />
        </Box>
        <Box>
          <Typography variant="h5" fontWeight={700}>
            Create New Document
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
            Generate quotation or proforma invoice for your customer
          </Typography>
        </Box>
      </Box>
      <IconButton 
        onClick={() => setOpenDialog(false)}
        sx={{ 
          color: theme.palette.primary.contrastText,
          '&:hover': { backgroundColor: alpha(theme.palette.common.white, 0.1) }
        }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  </DialogTitle>

  <DialogContent
    dividers
    sx={{
      p: 0,
      backgroundColor: theme.palette.background.default,
      overflowY: "auto",
      flex: 1,
    }}
  >
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ mb: 2, display: "flex", justifyContent: { xs: "flex-start", sm: "flex-end" } }}>
          <Chip
            label={`Step ${formStep + 1} of ${totalFormSteps}`}
            color="primary"
            variant="outlined"
            sx={{ fontWeight: 600, height: 32 }}
          />
        </Box>

        {formStep === 0 && (
        <Card sx={{ mb: 2, borderRadius: 2, boxShadow: 1.5, border: `1px solid ${theme.palette.divider}` }}>
          <CardHeader
            title="Document Type"
            titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
            subheader="Choose the type of document you want to create"
            subheaderTypographyProps={{ variant: "body2", color: "text.secondary" }}
            sx={{ pb: 1.25 }}
          />
          <CardContent>
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: { xs: 1.5, sm: 2 } }}>
              <TextField
                fullWidth
                size="medium"
                label="Document Type"
                required
                value={
                  quotationTypes.find((opt) => opt.value === formData.quotation_type)?.label ||
                  quotationTypes[0]?.label ||
                  'Quotation'
                }
                InputProps={{ readOnly: true }}
                error={!!formErrors.quotation_type}
                helperText={formErrors.quotation_type}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  },
                }}
              />

              <TextField
                select
                fullWidth
                size="medium"
                label="Status"
                required
                value={formData.status}
                onChange={(e) => handleFormDataChange('status', e.target.value)}
                error={!!formErrors.status}
                helperText={formErrors.status}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  },
                  '& .MuiSelect-select': {
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }
                }}
              >
                {Array.isArray(statusOptions) &&
                  statusOptions.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label || opt.value}
                    </MenuItem>
                  ))}
              </TextField>


            </Box>
          </CardContent>
        </Card>
        )}

        {formStep === 1 && (
        <Card sx={{ mb: 2, borderRadius: 2, boxShadow: 2 }}>
          <CardHeader
            title="Customer Information"
            titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
            subheader="Enter customer details and contact information"
            subheaderTypographyProps={{ variant: "body2", color: "text.secondary" }}
          />
          <CardContent>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                gap: 2,
              }}
            >
  <TextField
  fullWidth
  size="medium"
  label="Customer Name"
  value={formData.name}
  onChange={(e) => {
    const lettersOnly = e.target.value.replace(/[^A-Za-z]/g, '');
    handleFormDataChange('name', lettersOnly);
  }}
  required
  error={!!formErrors.name}
  helperText={formErrors.name}
  sx={{
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    }
  }}
/>

<TextField
  fullWidth
  size="medium"
  label="Contact Number"
  value={formData.contact_number}
  onChange={(e) => {
    const digitsOnly = e.target.value.replace(/\D/g, '');
    handleFormDataChange('contact_number', digitsOnly);
  }}
  required
  error={!!formErrors.contact_number}
  helperText={formErrors.contact_number}
  inputProps={{
    maxLength: 10,
  }}
  sx={{
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    }
  }}
/>

<TextField
  fullWidth
  size="medium"
  label="Alternate Number"
  value={formData.alternate_number}
  onChange={(e) => {
    const digitsOnly = e.target.value.replace(/\D/g, '');
    setFormData({ ...formData, alternate_number: digitsOnly });
  }}
  inputProps={{
    maxLength: 10,
  }}
  sx={{
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    }
  }}
/>

<TextField
  fullWidth
  size="medium"
  type="email"
  label="Email Address"
  required
  value={formData.email || ""}
  onChange={(e) => handleFormDataChange('email', e.target.value)}
  error={!!formErrors.email}
  helperText={formErrors.email}
  sx={{
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    }
  }}
/>

<TextField
                select
                fullWidth
                size="medium"
                label="Category"
                required
                value={formData.category}
                onChange={(e) => handleFormDataChange('category', e.target.value)}
                error={!!formErrors.category}
                helperText={formErrors.category}
                SelectProps={{ native: true }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  }
                }}
              >
                <option value="">Select Category</option>
                {Array.isArray(categoryOptions) &&
                  categoryOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label || opt.value}
                    </option>
                  ))}
              </TextField>

              <TextField
                select
                fullWidth
                size="medium"
                label="Source"
                required
                value={formData.source}
                onChange={(e) => handleFormDataChange('source', e.target.value)}
                error={!!formErrors.source}
                helperText={formErrors.source}
                SelectProps={{ native: true }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  }
                }}
              >
                <option value="">Select Source</option>
                {Array.isArray(sourceOptions) &&
                  sourceOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label || opt.value}
                    </option>
                  ))}
              </TextField>

              {/* <TextField
                select
                fullWidth
                size="medium"
                label="Category"
                required
                value={formData.category}
                onChange={(e) => handleFormDataChange('category', e.target.value)}
                error={!!formErrors.category}
                helperText={formErrors.category}
                SelectProps={{ native: true }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  }
                }}
              >
                <option value="">Select Category</option>
                {Array.isArray(categoryOptions) &&
                  categoryOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label || opt.value}
                    </option>
                  ))}
              </TextField> */}
{!isGstHiddenForCategory() && (
  <TextField
    fullWidth
    size="medium"
    label="GST Number"
    value={formData.gst_no}
    onChange={(e) => handleFormDataChange('gst_no', e.target.value.toUpperCase())}
    error={!!formErrors.gst_no}
    helperText={formErrors.gst_no}
    inputProps={{
      maxLength: 15
    }}
    sx={{
      '& .MuiOutlinedInput-root': {
        borderRadius: 2,
      }
    }}
  />
)}

       

            <DesktopDatePicker
              label="Valid Until"
              inputFormat="DD/MM/YYYY"
              value={formData.valid_until ? dayjs(formData.valid_until) : null}
              minDate={dayjs()}  
              onChange={(newValue) => {
                const value = newValue ? dayjs(newValue).format("YYYY-MM-DD") : "";
                handleFormDataChange('valid_until', value);
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "medium",
                  required: true,
                  error: !!formErrors.valid_until,
                  helperText: formErrors.valid_until || "",
                  sx: {
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                    },
                  }
                }
              }}
            />

            </Box>
          </CardContent>
        </Card>
        )}

        {formStep === 2 && (
        <Card sx={{ mb: 2, borderRadius: 2, boxShadow: 2 }}>
          <CardHeader
            title="Address Information"
            titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
            subheader="Customer's complete address details"
            subheaderTypographyProps={{ variant: "body2", color: "text.secondary" }}
          />
          <CardContent>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                gap: 2,
              }}
            >
            <TextField
              fullWidth
              size="medium"
              label="Address"
              value={formData.address}
              onChange={(e) => handleFormDataChange('address', e.target.value)}
              multiline
              rows={2}
              required
              error={!!formErrors.address}
              helperText={formErrors.address}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                }
              }}
            />

          <TextField
            fullWidth
            size="medium"
            label="Village"
            required
            value={formData.village}
            onChange={(e) => {
              const rawValue = e.target.value;
              // Remove any character that is not a letter or space
              const lettersOnly = rawValue.replace(/[^A-Za-z ]/g, '');
              handleFormDataChange('village', lettersOnly);
            }}
            error={!!formErrors.village}
            helperText={formErrors.village}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              }
            }}
          />

              <TextField
                select
                fullWidth
                size="medium"
                label="Country"
                required
                value={formData.country}
                onChange={(e) => {
                  const selectedCountry = e.target.value;
                  handleFormDataChange('country', selectedCountry);
                  setFormData(prev => ({ ...prev, state: "", district: "", taluka: "" })); 
                  fetchStates(selectedCountry); 
                }}
                error={!!formErrors.country}
                helperText={formErrors.country}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
              >
                {countries.length > 0 ? (
                  countries.map((item) => (
                    <MenuItem key={item.id} value={item.name}>
                      {item.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>Loading countries...</MenuItem>
                )}
              </TextField>



      <TextField
  select
  fullWidth
  size="medium"
  label="State"
  required
  value={formData.state}
  onChange={(e) => {
    const selectedState = e.target.value;
    handleFormDataChange('state', selectedState);
    setFormData(prev => ({ ...prev, district: "", taluka: "" })); 
    fetchDistricts(selectedState); 
  }}
  error={!!formErrors.state}
  helperText={formErrors.state}
  sx={{
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
    },
  }}
>
  {states.length > 0 ? (
    states.map((item) => (
      <MenuItem key={item.id} value={item.name}>
        {item.name}
      </MenuItem>
    ))
  ) : (
    <MenuItem disabled>Select a country first</MenuItem>
  )}
</TextField>


<TextField
  select
  fullWidth
  size="medium"
  label="District"
  required
  value={formData.district}
  onChange={(e) => {
    const selectedDistrict = e.target.value;
    handleFormDataChange('district', selectedDistrict);
    setFormData(prev => ({ ...prev, taluka: "" })); 
    fetchTalukas(selectedDistrict); 
  }}
  error={!!formErrors.district}
  helperText={formErrors.district}
  sx={{
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
    },
  }}
>
  {districts.length > 0 ? (
    districts.map((item) => (
      <MenuItem key={item.id} value={item.name}>
        {item.name}
      </MenuItem>
    ))
  ) : (
    <MenuItem disabled>Select a state first</MenuItem>
  )}
</TextField>



       <TextField
  select
  fullWidth
  size="medium"
  label="Taluka"
  required
  value={formData.taluka}
  onChange={(e) => handleFormDataChange('taluka', e.target.value)}
  error={!!formErrors.taluka}
  helperText={formErrors.taluka}
  sx={{
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
    },
  }}
>
  {talukas.length > 0 ? (
    talukas.map((item) => (
      <MenuItem key={item.id} value={item.name}>
        {item.name}
      </MenuItem>
    ))
  ) : (
    <MenuItem disabled>Select a district first</MenuItem>
  )}
</TextField>
              <TextField
                fullWidth
                size="medium"
                label="Post"
                required
                value={formData.post}
                onChange={(e) => handleFormDataChange('post', e.target.value)}
                error={!!formErrors.post}
                helperText={formErrors.post}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  }
                }}
              />

            <TextField
              fullWidth
              size="medium"
              label="Pincode"
              required
              value={formData.pincode}
              onChange={(e) => {
                const rawValue = e.target.value;
                // Keep only digits (0-9) and limit to 6 characters
                const digitsOnly = rawValue.replace(/\D/g, '').slice(0, 6);
                handleFormDataChange('pincode', digitsOnly);
              }}
              error={!!formErrors.pincode}
              helperText={formErrors.pincode}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                }
              }}
            />

<TextField
  fullWidth
  size="medium"
  label="Executive Name"
  required
  value={formData.order_poc}
  onChange={(e) => {
    const rawValue = e.target.value;
    // Remove any character that is not a letter (A-Z, a-z) or space
    const lettersOnly = rawValue.replace(/[^A-Za-z ]/g, '');
    handleFormDataChange('order_poc', lettersOnly);
  }}
  error={!!formErrors.order_poc}
  helperText={formErrors.order_poc}
  sx={{
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    }
  }}
/>
            </Box>
          </CardContent>
        </Card>
        )}
        {formStep === 3 && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Card sx={{ borderRadius: 3, boxShadow: 3, border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}` }}>
            <CardHeader
              avatar={
                <Box sx={{ 
                  p: 1.5, 
                  borderRadius: 2, 
                  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <ShoppingCart sx={{ color: 'white', fontSize: 28 }} />
                </Box>
              }
              title={
                <Typography variant="h5" fontWeight={700} sx={{ color: theme.palette.text.primary }}>
                  Add New Product
                </Typography>
              }
              subheader={
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                  Select company, category, product, quantity and unit to add items
                </Typography>
              }
              action={
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    setProductRows([
                      ...productRows,
                      {
                        id: generateRowId(), 
                        company_id: "",
                        category_id: "",
                        categoryOptions: [],
                        product_id: "",
                        productOptions: [],
                        quantity: "",
                        unit_id: "",
                      },
                    ])
                  }
                  sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    px: 3,
                    py: 1,
                    background: `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
                    '&:hover': {
                      background: `linear-gradient(135deg, ${theme.palette.success.dark} 0%, ${theme.palette.success.main} 100%)`,
                    }
                  }}
                >
                  Add Row
                </Button>
              }
            />
            <CardContent>
              {productRows.length === 0 ? (
                <Box sx={{ 
                  textAlign: 'center', 
                  py: 6,
                  border: `2px dashed ${alpha(theme.palette.primary.main, 0.2)}`,
                  borderRadius: 2,
                  backgroundColor: alpha(theme.palette.primary.main, 0.02)
                }}>
                  <ShoppingCart sx={{ fontSize: 48, color: 'text.secondary', mb: 2, opacity: 0.5 }} />
                  <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
                    No product rows added yet
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Click "Add Row" button above to start adding products
                  </Typography>
                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={() =>
                      setProductRows([
                        {
                          id: generateRowId(), 
                          company_id: "",
                          category_id: "",
                          categoryOptions: [],
                          product_id: "",
                          productOptions: [],
                          quantity: "",
                          unit_id: "",
                        },
                      ])
                    }
                    sx={{
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: 600,
                      px: 3
                    }}
                  >
                    Add First Product Row
                  </Button>
                </Box>
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                  {productRows.map((row, index) => (
                    <Card 
                      key={row.id || index}
                      sx={{ 
                        p: 3, 
                        borderRadius: 2, 
                        backgroundColor: alpha(theme.palette.primary.main, 0.02),
                        border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          boxShadow: 2,
                          borderColor: alpha(theme.palette.primary.main, 0.3)
                        }
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                       
                        <Typography variant="body2" color="text.secondary">
                          Fill in the details below to add this product
                        </Typography>
                      </Box>
                      
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={3}>
                          <TextField
                            select
                            fullWidth
                            size="small"
                            label="Company"
                            required
                            value={row.company_id || ""}
                            onChange={async (e) => {
                              const newCompanyId = e.target.value;
                              
                              if (savedProducts.length > 0 && newCompanyId) {
                                const existingCompanyId = savedProducts[0].company_id;
                                
                                if (existingCompanyId && existingCompanyId.toString() !== newCompanyId.toString()) {
                                  const existingCompanyName = companyOptions.find(c => c.id.toString() === existingCompanyId.toString())?.name || 'the existing company';
                                  const newCompanyName = companyOptions.find(c => c.id.toString() === newCompanyId.toString())?.name || 'the new company';
                                  
                                  setCompanyMismatchDialog({
                                    open: true,
                                    pendingProduct: null,
                                    pendingRowIndex: index,
                                    pendingCompanyChange: newCompanyId,
                                    existingCompany: existingCompanyName,
                                    newCompany: newCompanyName
                                  });
                                  return;
                                }
                              }
                              
                              const updatedRows = [...productRows];
                              updatedRows[index].company_id = newCompanyId;
                              updatedRows[index].category_id = "";
                              updatedRows[index].categoryOptions = [];
                              updatedRows[index].product_id = "";
                              updatedRows[index].productOptions = [];
                              setProductRows(updatedRows);
                              await fetchCategoriesByCompany(newCompanyId, index);
                            }}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                              }
                            }}
                          >
                            <MenuItem value="">Select Company</MenuItem>
                            {companyOptions.map((c) => (
                              <MenuItem key={c.id} value={c.id}>
                                {c.name}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <TextField
                            select
                            fullWidth
                            size="small"
                            label="Product Category"
                            required
                            disabled={!row.company_id}
                            value={row.category_id || ""}
                            onChange={async (e) => {
                              const updatedRows = [...productRows];
                              updatedRows[index].category_id = e.target.value;
                              updatedRows[index].product_id = "";
                              updatedRows[index].productOptions = [];
                              setProductRows(updatedRows);
                              await fetchProductsByCompanyAndCategory(
                                row.company_id,
                                e.target.value,
                                index
                              );
                            }}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                              }
                            }}
                          >
                            <MenuItem value="">Select Category</MenuItem>
                            {(row.categoryOptions || []).map((cat) => (
                              <MenuItem key={cat.id} value={cat.id}>
                                {cat.name}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <TextField
                            select
                            fullWidth
                            size="small"
                            label="Product"
                            required
                            disabled={!row.category_id}
                            value={row.product_id || ""}
                            onChange={(e) => {
                              const updatedRows = [...productRows];
                              updatedRows[index].product_id = e.target.value;
                              setProductRows(updatedRows);
                            }}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                              }
                            }}
                          >
                            <MenuItem value="">Select Product</MenuItem>
                            {(row.productOptions || []).map((p) => (
                              <MenuItem key={p.id} value={p.id}>
                                {p.name}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <Box sx={{ display: "flex", gap: 1 }}>
                            <TextField
                              type="number"
                              size="small"
                              label="Quantity"
                              required
                              value={row.quantity}
                              onChange={(e) => {
                                const updatedRows = productRows.map((r, i) =>
                                  i === index ? { ...r, quantity: e.target.value } : r
                                );
                                setProductRows(updatedRows);
                              }}
                              sx={{
                                flex: 1,
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                }
                              }}
                              inputProps={{ min: 0, step: 1 }}
                            />
                            <TextField
                              select
                              size="small"
                              label="Unit"
                              required
                              value={row.unit_id?.toString() || ""}
                              onChange={(e) => {
                                const updatedRows = [...productRows];
                                updatedRows[index].unit_id = e.target.value;
                                setProductRows(updatedRows);
                              }}
                              sx={{
                                width: 120,
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                }
                              }}
                            >
                              <MenuItem value="">Select Unit</MenuItem>
                              {measureUnits.map((unit) => (
                                <MenuItem key={unit.id} value={unit.id.toString()}>
                                  {unit.name}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mt: 1 }}>
                            <Button
                              size="medium"
                              color="error"
                              variant="outlined"
                              startIcon={<Delete />}
                              onClick={() => {
                                setProductRows(productRows.filter((_, i) => i !== index));
                              }}
                              sx={{
                                borderRadius: 2,
                                textTransform: 'none',
                                fontWeight: 600,
                                px: 3
                              }}
                            >
                              Remove Row
                            </Button>

                            <Button
                              size="medium"
                              variant="contained"
                              startIcon={<AddIcon />}
                              disabled={!row.company_id || !row.category_id || !row.product_id || !row.quantity || !row.unit_id}
                              onClick={() => {
                                const currentRow = productRows[index];

                                if (!currentRow.company_id || !currentRow.category_id || !currentRow.product_id || !currentRow.quantity || !currentRow.unit_id) {
                                  showError("Please fill in all fields before adding the product.");
                                  return;
                                }

                                if (savedProducts.length > 0) {
                                  const existingCompanyId = savedProducts[0].company_id;
                                  const newCompanyId = currentRow.company_id;
                                  
                                  if (existingCompanyId && newCompanyId && existingCompanyId.toString() !== newCompanyId.toString()) {
                                    const existingCompanyName = companyOptions.find(c => c.id.toString() === existingCompanyId.toString())?.name || 'the existing company';
                                    const newCompanyName = companyOptions.find(c => c.id.toString() === newCompanyId.toString())?.name || 'the new company';
                                    
                                    setCompanyMismatchDialog({
                                      open: true,
                                      pendingProduct: currentRow,
                                      pendingRowIndex: index,
                                      existingCompany: existingCompanyName,
                                      newCompany: newCompanyName
                                    });
                                    return;
                                  }
                                }

                                handleAddProduct(currentRow, index);
                              }}
                              sx={{
                                borderRadius: 2,
                                textTransform: 'none',
                                fontWeight: 600,
                                px: 3,
                                background: `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
                                '&:hover': {
                                  background: `linear-gradient(135deg, ${theme.palette.success.dark} 0%, ${theme.palette.success.main} 100%)`,
                                },
                                '&:disabled': {
                                  background: theme.palette.action.disabledBackground
                                }
                              }}
                            >
                              Add Product
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Card>
                  ))}
                </Box>
              )}
            </CardContent>
          </Card>

          <Card sx={{ borderRadius: 3, boxShadow: 3, border: `1px solid ${alpha(theme.palette.success.main, 0.1)}` }}>
            <CardHeader
              avatar={
                <Box sx={{ 
                  p: 1.5, 
                  borderRadius: 2, 
                  background: `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <ShoppingCart sx={{ color: 'white', fontSize: 28 }} />
                </Box>
              }
              title={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Typography variant="h5" fontWeight={700} sx={{ color: theme.palette.text.primary }}>
                    Added Products
                  </Typography>
                  {savedProducts.length > 0 && (
                    <Chip 
                      label={`${savedProducts.length} ${savedProducts.length === 1 ? 'Product' : 'Products'}`} 
                      color="success" 
                      size="small"
                      sx={{ fontWeight: 600 }}
                    />
                  )}
                </Box>
              }
              subheader={
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                  Review and manage products added to your quotation
                </Typography>
              }
            />
            <CardContent>
              {savedProducts.length === 0 ? (
                <Box sx={{ 
                  textAlign: 'center', 
                  py: 8,
                  border: `2px dashed ${alpha(theme.palette.success.main, 0.2)}`,
                  borderRadius: 2,
                  backgroundColor: alpha(theme.palette.success.main, 0.02)
                }}>
                  <ShoppingCart sx={{ fontSize: 64, color: 'text.secondary', mb: 2, opacity: 0.3 }} />
                  <Typography variant="h6" color="text.secondary" sx={{ mb: 1, fontWeight: 600 }}>
                    No products added yet
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Add products using the form above to see them here
                  </Typography>
                </Box>
              ) : (
                <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 'none', border: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
                  <Table size="medium">
                    <TableHead>
                      <TableRow sx={{ 
                        backgroundColor: alpha(theme.palette.success.main, 0.08),
                        '& th': {
                          fontWeight: 700,
                          color: theme.palette.text.primary,
                          borderBottom: `2px solid ${alpha(theme.palette.success.main, 0.2)}`
                        }
                      }}>
                        <TableCell>Sr No</TableCell>
                        <TableCell>Company</TableCell>
                        <TableCell>Category</TableCell>
                        <TableCell>Product</TableCell>
                        <TableCell align="center">Quantity</TableCell>
                        <TableCell align="center">Unit</TableCell>
                        <TableCell align="center">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {savedProducts.map((row, i) => (
                        <TableRow 
                          key={i}
                          sx={{
                            '&:hover': {
                              backgroundColor: alpha(theme.palette.success.main, 0.04)
                            },
                            '&:last-child td': {
                              borderBottom: 'none'
                            }
                          }}
                        >
                          <TableCell>
                            <Chip label={i + 1} size="small" color="primary" variant="outlined" />
                          </TableCell>
                          <TableCell>
                            <Tooltip title={companyOptions.find((c) => c.id === row.company_id)?.name || "-"} arrow>
                              <Typography 
                                variant="body2" 
                                fontWeight={500}
                                sx={{ 
                                  maxWidth: 120, 
                                  overflow: 'hidden', 
                                  textOverflow: 'ellipsis', 
                                  whiteSpace: 'nowrap',
                                  cursor: 'help'
                                }}
                              >
                                {companyOptions.find((c) => c.id === row.company_id)?.name || "-"}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Tooltip title={row.categoryOptions?.find((c) => c.id === row.category_id)?.name || "-"} arrow>
                              <Typography 
                                variant="body2"
                                sx={{ 
                                  maxWidth: 120, 
                                  overflow: 'hidden', 
                                  textOverflow: 'ellipsis', 
                                  whiteSpace: 'nowrap',
                                  cursor: 'help'
                                }}
                              >
                                {row.categoryOptions?.find((c) => c.id === row.category_id)?.name || "-"}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Tooltip title={row.productOptions?.find((p) => p.id === row.product_id)?.name || "-"} arrow>
                              <Typography 
                                variant="body2" 
                                fontWeight={600}
                                sx={{ 
                                  maxWidth: 200, 
                                  overflow: 'hidden', 
                                  textOverflow: 'ellipsis', 
                                  whiteSpace: 'nowrap',
                                  cursor: 'help'
                                }}
                              >
                                {row.productOptions?.find((p) => p.id === row.product_id)?.name || "-"}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="center">
                            <Chip 
                              label={row.quantity} 
                              size="small" 
                              color="primary" 
                              variant="filled"
                              sx={{ fontWeight: 600 }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="body2" color="text.secondary">
                              {measureUnits.find((u) => u.id.toString() === row.unit_id?.toString())?.name || "-"}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Tooltip title="Remove product">
                              <IconButton
                                color="error"
                                size="small"
                                onClick={() => {
                                  setSavedProducts(savedProducts.filter((_, index) => index !== i));
                                  showSuccess("Product removed successfully!");
                                }}
                                sx={{
                                  '&:hover': {
                                    backgroundColor: alpha(theme.palette.error.main, 0.1)
                                  }
                                }}
                              >
                                <Delete />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </CardContent>
          </Card>
        </Box>
        )}

      {formStep === 4 && (
      <Card sx={{ mb: 2, borderRadius: 2, boxShadow: 2 }}>
  <CardHeader
    title="Payment Terms"
    titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
    subheader="Configure payment conditions"
    subheaderTypographyProps={{ variant: "body2", color: "text.secondary" }}
  />
  <CardContent>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
        gap: 2,
      }}
    >
      <TextField
        select
        fullWidth
        size="medium"
        label="Payment Mode"
        required
        value={formData.payment_mode}
        onChange={(e) => handleFormDataChange('payment_mode', e.target.value)}
        error={!!formErrors.payment_mode}
        helperText={formErrors.payment_mode}
        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
      >
        <option value="">Select Payment Mode</option>
        {Array.isArray(paymentModeOptions) &&
          paymentModeOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label || opt.value}
            </MenuItem>
          ))}
      </TextField>

      <TextField
        select
        fullWidth
        size="medium"
        label="Payment Terms"
        required
        value={formData.payment_terms}
        onChange={(e) => handleFormDataChange('payment_terms', e.target.value)}
        error={!!formErrors.payment_terms}
        helperText={formErrors.payment_terms}
        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
      >
        <MenuItem value="">Select Payment Terms</MenuItem>
        <MenuItem value="30% Advance">30% Advance</MenuItem>
        <MenuItem value="50% Advance">50% Advance</MenuItem>
        <MenuItem value="Full Payment">Full Payment</MenuItem>
      </TextField>
    </Box>
  </CardContent>
</Card>
      )}


        {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Card sx={{ borderRadius: 3, boxShadow: 3, border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}` }}>
            <CardHeader
              avatar={
                <Box sx={{ 
                  p: 1.5, 
                  borderRadius: 2, 
                  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <ShoppingCart sx={{ color: 'white', fontSize: 28 }} />
                </Box>
              }
              title={
                <Typography variant="h5" fontWeight={700} sx={{ color: theme.palette.text.primary }}>
                  Add New Product
                </Typography>
              }
              subheader={
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                  Select company, category, product, quantity and unit to add items
                </Typography>
              }
              action={
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    setProductRows([
                      ...productRows,
                      {
                        id: generateRowId(), 
                        company_id: "",
                        category_id: "",
                        categoryOptions: [],
                        product_id: "",
                        productOptions: [],
                        quantity: "",
                        unit_id: "",
                      },
                    ])
                  }
                  sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    px: 3,
                    py: 1,
                    background: `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
                    '&:hover': {
                      background: `linear-gradient(135deg, ${theme.palette.success.dark} 0%, ${theme.palette.success.main} 100%)`,
                    }
                  }}
                >
                  Add Row
                </Button>
              }
            />
            <CardContent>
              {productRows.length === 0 ? (
                <Box sx={{ 
                  textAlign: 'center', 
                  py: 6,
                  border: `2px dashed ${alpha(theme.palette.primary.main, 0.2)}`,
                  borderRadius: 2,
                  backgroundColor: alpha(theme.palette.primary.main, 0.02)
                }}>
                  <ShoppingCart sx={{ fontSize: 48, color: 'text.secondary', mb: 2, opacity: 0.5 }} />
                  <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
                    No product rows added yet
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Click "Add Row" button above to start adding products
                  </Typography>
                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={() =>
                      setProductRows([
                        {
                          id: generateRowId(), 
                          company_id: "",
                          category_id: "",
                          categoryOptions: [],
                          product_id: "",
                          productOptions: [],
                          quantity: "",
                          unit_id: "",
                        },
                      ])
                    }
                    sx={{
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: 600,
                      px: 3
                    }}
                  >
                    Add First Product Row
                  </Button>
                </Box>
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                  {productRows.map((row, index) => (
                    <Card 
                      key={row.id || index}
                      sx={{ 
                        p: 3, 
                        borderRadius: 2, 
                        backgroundColor: alpha(theme.palette.primary.main, 0.02),
                        border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          boxShadow: 2,
                          borderColor: alpha(theme.palette.primary.main, 0.3)
                        }
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                       
                        <Typography variant="body2" color="text.secondary">
                          Fill in the details below to add this product
                        </Typography>
                      </Box>
                      
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={3}>
                          <TextField
                            select
                            fullWidth
                            size="small"
                            label="Company"
                            required
                            value={row.company_id || ""}
                            onChange={async (e) => {
                              const newCompanyId = e.target.value;
                              
                              if (savedProducts.length > 0 && newCompanyId) {
                                const existingCompanyId = savedProducts[0].company_id;
                                
                                if (existingCompanyId && existingCompanyId.toString() !== newCompanyId.toString()) {
                                  const existingCompanyName = companyOptions.find(c => c.id.toString() === existingCompanyId.toString())?.name || 'the existing company';
                                  const newCompanyName = companyOptions.find(c => c.id.toString() === newCompanyId.toString())?.name || 'the new company';
                                  
                                  setCompanyMismatchDialog({
                                    open: true,
                                    pendingProduct: null,
                                    pendingRowIndex: index,
                                    pendingCompanyChange: newCompanyId,
                                    existingCompany: existingCompanyName,
                                    newCompany: newCompanyName
                                  });
                                  return;
                                }
                              }
                              
                              const updatedRows = [...productRows];
                              updatedRows[index].company_id = newCompanyId;
                              updatedRows[index].category_id = "";
                              updatedRows[index].categoryOptions = [];
                              updatedRows[index].product_id = "";
                              updatedRows[index].productOptions = [];
                              setProductRows(updatedRows);
                              await fetchCategoriesByCompany(newCompanyId, index);
                            }}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                              }
                            }}
                          >
                            <MenuItem value="">Select Company</MenuItem>
                            {companyOptions.map((c) => (
                              <MenuItem key={c.id} value={c.id}>
                                {c.name}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <TextField
                            select
                            fullWidth
                            size="small"
                            label="Product Category"
                            required
                            disabled={!row.company_id}
                            value={row.category_id || ""}
                            onChange={async (e) => {
                              const updatedRows = [...productRows];
                              updatedRows[index].category_id = e.target.value;
                              updatedRows[index].product_id = "";
                              updatedRows[index].productOptions = [];
                              setProductRows(updatedRows);
                              await fetchProductsByCompanyAndCategory(
                                row.company_id,
                                e.target.value,
                                index
                              );
                            }}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                              }
                            }}
                          >
                            <MenuItem value="">Select Category</MenuItem>
                            {(row.categoryOptions || []).map((cat) => (
                              <MenuItem key={cat.id} value={cat.id}>
                                {cat.name}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <TextField
                            select
                            fullWidth
                            size="small"
                            label="Product"
                            required
                            disabled={!row.category_id}
                            value={row.product_id || ""}
                            onChange={(e) => {
                              const updatedRows = [...productRows];
                              updatedRows[index].product_id = e.target.value;
                              setProductRows(updatedRows);
                            }}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                              }
                            }}
                          >
                            <MenuItem value="">Select Product</MenuItem>
                            {(row.productOptions || []).map((p) => (
                              <MenuItem key={p.id} value={p.id}>
                                {p.name}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <Box sx={{ display: "flex", gap: 1 }}>
                            <TextField
                              type="number"
                              size="small"
                              label="Quantity"
                              required
                              value={row.quantity}
                              onChange={(e) => {
                                const updatedRows = productRows.map((r, i) =>
                                  i === index ? { ...r, quantity: e.target.value } : r
                                );
                                setProductRows(updatedRows);
                              }}
                              sx={{
                                flex: 1,
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                }
                              }}
                              inputProps={{ min: 0, step: 1 }}
                            />
                            <TextField
                              select
                              size="small"
                              label="Unit"
                              required
                              value={row.unit_id?.toString() || ""}
                              onChange={(e) => {
                                const updatedRows = [...productRows];
                                updatedRows[index].unit_id = e.target.value;
                                setProductRows(updatedRows);
                              }}
                              sx={{
                                width: 120,
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                }
                              }}
                            >
                              <MenuItem value="">Select Unit</MenuItem>
                              {measureUnits.map((unit) => (
                                <MenuItem key={unit.id} value={unit.id.toString()}>
                                  {unit.name}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mt: 1 }}>
                            <Button
                              size="medium"
                              color="error"
                              variant="outlined"
                              startIcon={<Delete />}
                              onClick={() => {
                                setProductRows(productRows.filter((_, i) => i !== index));
                              }}
                              sx={{
                                borderRadius: 2,
                                textTransform: 'none',
                                fontWeight: 600,
                                px: 3
                              }}
                            >
                              Remove Row
                            </Button>

                            <Button
                              size="medium"
                              variant="contained"
                              startIcon={<AddIcon />}
                              disabled={!row.company_id || !row.category_id || !row.product_id || !row.quantity || !row.unit_id}
                              onClick={() => {
                                const currentRow = productRows[index];

                                if (!currentRow.company_id || !currentRow.category_id || !currentRow.product_id || !currentRow.quantity || !currentRow.unit_id) {
                                  showError("Please fill in all fields before adding the product.");
                                  return;
                                }

                                if (savedProducts.length > 0) {
                                  const existingCompanyId = savedProducts[0].company_id;
                                  const newCompanyId = currentRow.company_id;
                                  
                                  if (existingCompanyId && newCompanyId && existingCompanyId.toString() !== newCompanyId.toString()) {
                                    const existingCompanyName = companyOptions.find(c => c.id.toString() === existingCompanyId.toString())?.name || 'the existing company';
                                    const newCompanyName = companyOptions.find(c => c.id.toString() === newCompanyId.toString())?.name || 'the new company';
                                    
                                    setCompanyMismatchDialog({
                                      open: true,
                                      pendingProduct: currentRow,
                                      pendingRowIndex: index,
                                      existingCompany: existingCompanyName,
                                      newCompany: newCompanyName
                                    });
                                    return;
                                  }
                                }

                                handleAddProduct(currentRow, index);
                              }}
                              sx={{
                                borderRadius: 2,
                                textTransform: 'none',
                                fontWeight: 600,
                                px: 3,
                                background: `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
                                '&:hover': {
                                  background: `linear-gradient(135deg, ${theme.palette.success.dark} 0%, ${theme.palette.success.main} 100%)`,
                                },
                                '&:disabled': {
                                  background: theme.palette.action.disabledBackground
                                }
                              }}
                            >
                              Add Product
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Card>
                  ))}
                </Box>
              )}
            </CardContent>
          </Card>

          <Card sx={{ borderRadius: 3, boxShadow: 3, border: `1px solid ${alpha(theme.palette.success.main, 0.1)}` }}>
            <CardHeader
              avatar={
                <Box sx={{ 
                  p: 1.5, 
                  borderRadius: 2, 
                  background: `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <ShoppingCart sx={{ color: 'white', fontSize: 28 }} />
                </Box>
              }
              title={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Typography variant="h5" fontWeight={700} sx={{ color: theme.palette.text.primary }}>
                    Added Products
                  </Typography>
                  {savedProducts.length > 0 && (
                    <Chip 
                      label={`${savedProducts.length} ${savedProducts.length === 1 ? 'Product' : 'Products'}`} 
                      color="success" 
                      size="small"
                      sx={{ fontWeight: 600 }}
                    />
                  )}
                </Box>
              }
              subheader={
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                  Review and manage products added to your quotation
                </Typography>
              }
            />
            <CardContent>
              {savedProducts.length === 0 ? (
                <Box sx={{ 
                  textAlign: 'center', 
                  py: 8,
                  border: `2px dashed ${alpha(theme.palette.success.main, 0.2)}`,
                  borderRadius: 2,
                  backgroundColor: alpha(theme.palette.success.main, 0.02)
                }}>
                  <ShoppingCart sx={{ fontSize: 64, color: 'text.secondary', mb: 2, opacity: 0.3 }} />
                  <Typography variant="h6" color="text.secondary" sx={{ mb: 1, fontWeight: 600 }}>
                    No products added yet
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Add products using the form above to see them here
                  </Typography>
                </Box>
              ) : (
                <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 'none', border: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
                  <Table size="medium">
                    <TableHead>
                      <TableRow sx={{ 
                        backgroundColor: alpha(theme.palette.success.main, 0.08),
                        '& th': {
                          fontWeight: 700,
                          color: theme.palette.text.primary,
                          borderBottom: `2px solid ${alpha(theme.palette.success.main, 0.2)}`
                        }
                      }}>
                        <TableCell>Sr No</TableCell>
                        <TableCell>Company</TableCell>
                        <TableCell>Category</TableCell>
                        <TableCell>Product</TableCell>
                        <TableCell align="center">Quantity</TableCell>
                        <TableCell align="center">Unit</TableCell>
                        <TableCell align="center">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {savedProducts.map((row, i) => (
                        <TableRow 
                          key={i}
                          sx={{
                            '&:hover': {
                              backgroundColor: alpha(theme.palette.success.main, 0.04)
                            },
                            '&:last-child td': {
                              borderBottom: 'none'
                            }
                          }}
                        >
                          <TableCell>
                            <Chip label={i + 1} size="small" color="primary" variant="outlined" />
                          </TableCell>
                          <TableCell>
                            <Tooltip title={companyOptions.find((c) => c.id === row.company_id)?.name || "-"} arrow>
                              <Typography 
                                variant="body2" 
                                fontWeight={500}
                                sx={{ 
                                  maxWidth: 120, 
                                  overflow: 'hidden', 
                                  textOverflow: 'ellipsis', 
                                  whiteSpace: 'nowrap',
                                  cursor: 'help'
                                }}
                              >
                                {companyOptions.find((c) => c.id === row.company_id)?.name || "-"}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Tooltip title={row.categoryOptions?.find((c) => c.id === row.category_id)?.name || "-"} arrow>
                              <Typography 
                                variant="body2"
                                sx={{ 
                                  maxWidth: 120, 
                                  overflow: 'hidden', 
                                  textOverflow: 'ellipsis', 
                                  whiteSpace: 'nowrap',
                                  cursor: 'help'
                                }}
                              >
                                {row.categoryOptions?.find((c) => c.id === row.category_id)?.name || "-"}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Tooltip title={row.productOptions?.find((p) => p.id === row.product_id)?.name || "-"} arrow>
                              <Typography 
                                variant="body2" 
                                fontWeight={600}
                                sx={{ 
                                  maxWidth: 200, 
                                  overflow: 'hidden', 
                                  textOverflow: 'ellipsis', 
                                  whiteSpace: 'nowrap',
                                  cursor: 'help'
                                }}
                              >
                                {row.productOptions?.find((p) => p.id === row.product_id)?.name || "-"}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="center">
                            <Chip 
                              label={row.quantity} 
                              size="small" 
                              color="primary" 
                              variant="filled"
                              sx={{ fontWeight: 600 }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="body2" color="text.secondary">
                              {measureUnits.find((u) => u.id.toString() === row.unit_id?.toString())?.name || "-"}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Tooltip title="Remove product">
                              <IconButton
                                color="error"
                                size="small"
                                onClick={() => {
                                  setSavedProducts(savedProducts.filter((_, index) => index !== i));
                                  showSuccess("Product removed successfully!");
                                }}
                                sx={{
                                  '&:hover': {
                                    backgroundColor: alpha(theme.palette.error.main, 0.1)
                                  }
                                }}
                              >
                                <Delete />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </CardContent>
          </Card>
        </Box> */}
      </Box>
    </LocalizationProvider>
  </DialogContent>

  <DialogActions
    sx={{
      p: { xs: 2, sm: 3, md: 3.5 },
      gap: 1.25,
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.divider}`,
      display: "flex",
      flexWrap: "wrap",
      justifyContent: { xs: "stretch", sm: "flex-end" },
    }}
  >
    <Button
      onClick={() => setOpenDialog(false)}
      sx={{ 
        textTransform: "none",
        borderRadius: 2,
        px: { xs: 2, sm: 4 },
        py: 1.5,
        fontWeight: 600,
        minWidth: 120,
        height: 44,
        width: { xs: "100%", sm: "auto" },
      }}
    >
      Cancel
    </Button>

    {formStep > 0 && (
      <Button
        variant="outlined"
        onClick={handlePreviousStep}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          px: { xs: 2, sm: 4 },
          py: 1.5,
          borderRadius: 2,
          minWidth: 120,
          height: 44,
          width: { xs: "100%", sm: "auto" },
        }}
      >
        Back
      </Button>
    )}

    {formStep < totalFormSteps - 1 ? (
      <Button
        variant="contained"
        sx={{ 
          textTransform: "none", 
          fontWeight: 600, 
          px: { xs: 2, sm: 4 },
          py: 1.5,
          borderRadius: 2,
          minWidth: 120,
          height: 44,
          width: { xs: "100%", sm: "auto" },
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          '&:hover': {
            background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
          }
        }}
        onClick={handleNextStep}
      >
        Next
      </Button>
    ) : (
      <Button
        variant="contained"
        sx={{ 
          textTransform: "none", 
          fontWeight: 600, 
          px: { xs: 2, sm: 4 },
          py: 1.5,
          borderRadius: 2,
          minWidth: 120,
          height: 44,
          width: { xs: "100%", sm: "auto" },
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          '&:hover': {
            background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
          }
        }}
        onClick={async () => {
          const isFormValid = validateForm();
          
          if (!isFormValid) {
            return;
          }

          if (savedProducts.length === 0) {
            showError('Please add at least one product before submitting');
            return;
          }

          setSavingQuotation(true);
          try {
            const companyId = savedProducts.length > 0 ? savedProducts[0].company_id : null;
            
            if (!companyId) {
              showError('Please add at least one product with a company before submitting');
              return;
            }

            const items = savedProducts.map((product, index) => {
              const unit = measureUnits.find((u) => u.id.toString() === product.unit_id?.toString());
              return {
                product: product.product_id,
                serial_number: index + 1,
                quantity: product.quantity,
                unit: unit?.name || ''
              };
            });

            const payload = {
              ...formData,
              company: companyId,
              items
            };

            await apiService.post(API_ENDPOINTS.POST_add_quotation, payload);

            showSuccess("Quotation added successfully");
            
            setFormData({
              name: "",
              category: "",
              source: "",
              contact_number: "",
              alternate_number: "",
              address: "",
              village: "",
              post: "",
              taluka: "",
              district: "",
              state: "",
              pincode: "",
              gst_no: "",
              payment_mode: "",
              payment_terms: "",
              order_poc: "",
              quotation_type: "",
              status: "",
              valid_until: "",
              user: userId,
              company: "",
              email: "",
              country: ""
            });
            
            setFormErrors({
              name: '',
              contact_number: '',
              address: '',
              email: '',
              gst_no: '',
              quotation_type: '',
              status: '',
              company: '',
              source: '',
              category: '',
              valid_until: '',
              village: '',
              country: '',
              state: '',
              district: '',
              taluka: '',
              post: '',
              pincode: '',
              order_poc: '',
              payment_mode: '',
              payment_terms: ''
            });
            
            setSavedProducts([]);
            setProductRows([{
              id: generateRowId(),
              company_id: "",
              category_id: "",
              product_id: "",
              quantity: "",
              unit_id: "",
              categoryOptions: [],
              productOptions: [],
            }]);
            
            setOpenDialog(false);
            fetchQuotations(companyFilter || null, currentPage, pageSize);

          } catch (err) {
            const errorMessage = err?.response?.data?.message || err?.message || "Failed to add quotation";
            showError(errorMessage);
            console.error("Error adding quotation:", err);
          } finally {
            setSavingQuotation(false);
          }
        }}
        disabled={savingQuotation}
        startIcon={savingQuotation ? <CircularProgress size={16} color="inherit" /> : null}
      >
        {savingQuotation ? 'Saving...' : 'Save'}
      </Button>
    )}
  </DialogActions>
</Dialog>

      <Dialog
        open={companyMismatchDialog.open}
        onClose={handleCancelCompanyChange}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ 
          backgroundColor: theme.palette.warning.light,
          color: theme.palette.warning.contrastText,
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <ShoppingCart sx={{ fontSize: 24 }} />
          Different Company Detected
        </DialogTitle>
        <DialogContent sx={{ p: 3, mt: 2 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {companyMismatchDialog.pendingProduct ? (
              <>You are trying to add a product from <strong>{companyMismatchDialog.newCompany}</strong>, but you have already added products from <strong>{companyMismatchDialog.existingCompany}</strong>.</>
            ) : (
              <>You are trying to select <strong>{companyMismatchDialog.newCompany}</strong>, but you have already added products from <strong>{companyMismatchDialog.existingCompany}</strong>.</>
            )}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Products from different companies cannot be added to the same quotation. If you proceed, all previously added products will be removed.
          </Typography>
          <Alert severity="warning" sx={{ mt: 2 }}>
            {companyMismatchDialog.pendingProduct
              ? "Do you want to remove all existing products and add this product from the new company?"
              : "Do you want to remove all existing products and continue with the new company?"
            }
          </Alert>
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 2 }}>
          <Button
            onClick={handleCancelCompanyChange}
            variant="outlined"
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 4,
              py: 1.5,
              fontWeight: 600
            }}
          >
            No, Cancel
          </Button>
          <Button
            onClick={handleConfirmCompanyChange}
            variant="contained"
            color="warning"
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 4,
              py: 1.5,
              fontWeight: 600
            }}
          >
            Yes, Remove All & Add
          </Button>
        </DialogActions>
      </Dialog>

<InvoiceModal
  open={invoiceModal.open && !!invoiceModal.url}
  onClose={() => setInvoiceModal({ open: false, url: null, title: "", order: null })}
  maxWidth={false}
  fullWidth
>
  <DialogTitle>
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
           <Box sx={{display:"flex"}}>
      {invoiceModal.title === "Quotation PDF" ? (
        <PdfIcon color="error" />
      ) : (
        <ChallanIcon color="secondary" />
      )}
      <Typography variant="h6" sx={{fontWeight:"bold"}}>{invoiceModal.title}</Typography>
      </Box>
      <Box>

      <IconButton
        onClick={() =>
          setInvoiceModal({ open: false, url: null, title: "", order: null })
        }
      >
        <CloseIcon />
      </IconButton>
    </Box>
    </Box>
  </DialogTitle>
  <DialogContent sx={{ p: 0, height: "100%" }}>
    {invoiceModal.url ? (
      <InvoiceFrame src={invoiceModal.url} title={invoiceModal.title} />
    ) : (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Alert severity="warning">
          PDF is not available. Please generate the {invoiceModal.title} first.
        </Alert>
        <Button 
          variant="contained" 
          sx={{ mt: 2 }}
          onClick={() => setInvoiceModal({ open: false, url: null, title: "", order: null })}
        >
          Close
        </Button>
      </Box>
    )}
  </DialogContent>
</InvoiceModal>

<Dialog
  open={singleEmailDialog.open}
  onClose={closeSingleOrderEmail}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <EmailIcon color="primary" />
      <Typography variant="h6" fontWeight={600}>
        Send Documents via Email
      </Typography>
    </Box>
    {singleEmailDialog.order && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        Quotation No: {singleEmailDialog.order.quotation_number} •{' '}
      </Typography>
    )}
  </DialogTitle>

  <DialogContent>
    {singleEmailDialog.error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {singleEmailDialog.error}
      </Alert>
    )}
    {singleEmailDialog.success && (
      <Alert severity="success" sx={{ mb: 2 }}>
        {singleEmailDialog.success}
      </Alert>
    )}

    <Grid container spacing={2} p={1}>
      <Grid item xs={12}>
        <Box display="flex" gap={1}>
          <TextField
            fullWidth
            label="Add Email"
            placeholder="Enter email and click Add"
            value={singleEmailDialog.emailInput}
            onChange={(e) =>
              setSingleEmailDialog((prev) => ({ ...prev, emailInput: e.target.value }))
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                addEmailToSingle();
              }
            }}
          />
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={addEmailToSingle}
            sx={{ whiteSpace: 'nowrap' }}
          >
            Add
          </Button>
        </Box>

        <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {singleEmailDialog.emails.map((email) => (
            <Chip key={email} label={email} onDelete={() => removeEmailFromSingle(email)} />
          ))}
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={singleEmailDialog.sendInvoice}
                onChange={(e) =>
                  setSingleEmailDialog((prev) => ({
                    ...prev,
                    sendInvoice: e.target.checked,
                  }))
                }
              />
            }
           label="Proforma Invoice"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={singleEmailDialog.sendDelivery}
                onChange={(e) =>
                  setSingleEmailDialog((prev) => ({
                    ...prev,
                    sendDelivery: e.target.checked,
                  }))
                }
              />
            }
            label="Quotation"
          />
        </Box>
      </Grid>
    </Grid>
  </DialogContent>

  <DialogActions>
    <Button onClick={closeSingleOrderEmail} disabled={singleEmailDialog.isSending}>
      Cancel
    </Button>
    <Button
      variant="contained"
      startIcon={singleEmailDialog.isSending ? <CircularProgress size={16} /> : <SendIcon />}
      disabled={singleEmailDialog.isSending || !shouldEnableButton('send_email')}
      onClick={submitSingleOrderEmail}
      sx={{ textTransform: 'none', opacity: !shouldEnableButton('send_email') ? 0.6 : 1 }}
    >
      {singleEmailDialog.isSending ? 'Sending...' : 'Send Email'}
    </Button>
  </DialogActions>
</Dialog>

    </Box>
  );
};

export default QuotationProformaInvoice;